import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import * as Cookies from 'js-cookie';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

// Constant for Modal

import {
  FIRST_LOAN_FORM,
  SECOND_LOAN_FORM,
  FAQ,
  OTHER,
  LOGIN,
  EMPTY_LOAN,
  PAIDBACK,
} from './survey-content-type.constant';
import { surveyMessage, SurveyMessage } from './survey-message.constant';
import { TNK_LOAN_DATA } from '../../shared/constants/local-storage.constant';
import { StorageService } from '../../services/storage.service';
export class TNKSurveyComponent implements OnInit {
public surveyContentType: string;
public surveyMessage: SurveyMessage = surveyMessage;
public emoscorePoint: number = 0;
public cesPoint: number = 0;
public helpWidgetVisible: boolean = false;
public helpWidgetForm: FormGroup;
public userdata: any = null;
public widgetErrors: any = {
    content: '',
  };
public sendBusy: boolean = false;
public validationMessages: any = {
    content: {
      required: 'Isi pesan bantuan wajib diisi',
    },
  };

   hideHelpButton: boolean;
   media: string;
   openSuccessDialog = new EventEmitter<boolean>();
/**
 * @param {?} api
 * @param {?} http
 * @param {?} fb
 * @param {?} router
 * @param {?} storageService
 */
constructor(
public api: ApiConstant,
private http: HttpClient,
public fb: FormBuilder,
public router: Router,
private storageService: StorageService,
  ) {}
/**
 * @return {?}
 */
ngOnInit() {
    this.buildHelpWidgetForm();
    this.getCookiesUserData();
    this.setSurveyContentType();
  }
/**
 * @return {?}
 */
private setSurveyContentType() {
    if (
      this.router.url.includes('/loan/create-account') ||
      this.router.url.includes('/loan/application-form') ||
      this.router.url.includes('/load/success')
    ) {
      this.surveyContentType = FIRST_LOAN_FORM;
    } else if (this.router.url.includes('/second-loan')) {
      this.surveyContentType = SECOND_LOAN_FORM;
    } else if (this.router.url.includes('/customer/login')) {
      this.surveyContentType = LOGIN;
    } else if (
      this.router.url.includes('/kontak') ||
      this.router.url.includes('/tanya-jawab') ||
      this.router.url.includes('/faq')
    ) {
      this.surveyContentType = FAQ;
    } else if (this.router.url.includes('/loan-list')) {
      this.surveyContentType = OTHER;
    } else if (this.router.url.includes('/customer/dashboard')) {
      const /** @type {?} */ cookieLNStatus = Cookies.get('TNK-LN-STATUS');
      if (cookieLNStatus) {
        if (cookieLNStatus === EMPTY_LOAN) {
          this.surveyContentType = PAIDBACK;
        } else {
          this.surveyContentType = cookieLNStatus;
        }
      } else {
        this.surveyContentType = OTHER;
      }
    } else {
      this.surveyContentType = OTHER;
    }
  }
public handlePoint = (event, type?: string): void => {
    if (type) {
      this.emoscorePoint = event.target.value;
    } else {
      // + notation is to change the value from string to number
      this.cesPoint = +event.target.value;
    }
  };
/**
 * @return {?}
 */
private buildHelpWidgetForm() {
    this.helpWidgetForm = this.fb.group({
      content: new FormControl(''),
    });
    this.onChangedValues(this.helpWidgetForm.value);
    this.helpWidgetForm.valueChanges.subscribe(data =>
      this.onChangedValues(data),
    );
  }
/**
 * @return {?}
 */
private getCookiesUserData() {
    if (Cookies.get('tnk_user')) {
      this.userdata = ( /** @type {?} */((<any>Object))).assign(
        {},
        JSON.parse(Cookies.get('tnk_user')),
      );
    } else {
      this.userdata = null;
    }
  }
/**
 * @return {?}
 */
public sendHelpWidgetForm() {
    if (!this.sendBusy) {
      this.sendBusy = true;

      let /** @type {?} */ loanData: any;
      let /** @type {?} */ dashboardData: any;

      if (this.storageService.get(TNK_LOAN_DATA)) {
        loanData = JSON.parse(this.storageService.get(TNK_LOAN_DATA));
      }

      if (Cookies.get('tnk_user')) {
        dashboardData = JSON.parse(Cookies.get('tnk_user'));
      }

      let /** @type {?} */ profileData = {
        emailAddress: '',
        mobilePhoneNumber: '',
        dateOfBirth: '',
        mediasource: '',
        ktpName: '',
        pin: '',
        educationType: '',
        gender: '',
        loanpurpose_type: '',
        income_jobtype: '',
        income_employmentstatus: '',
        income_workposition: '',
        domicileAddress_city: '',
        contactAddress_city: '',
      };

      // For handle user data on First Loan
      if (loanData) {
        profileData = loanData;
      }

      // For handle user data on dashboard
      if (dashboardData) {
        profileData = {
          ktpName: dashboardData.name,
          emailAddress: dashboardData.email,
          dateOfBirth: dashboardData.dob,
          mediasource: dashboardData.mediasource,
          mobilePhoneNumber: dashboardData.phone,
          pin: dashboardData.citizen_id,
          educationType: dashboardData.education_type,
          gender: dashboardData.gender,
          loanpurpose_type: dashboardData.loanpurpose_type,
          income_jobtype: dashboardData.income_jobtype,
          income_employmentstatus: dashboardData.income_employmentstatus,
          income_workposition: dashboardData.income_workposition,
          domicileAddress_city: dashboardData.domicileAddressCity,
          contactAddress_city: dashboardData.contactAddressCity,
        };
      }

      const /** @type {?} */ data = {
        screenshot: null,
        ces_id: this.cesPoint,
        emoscore_id: this.emoscorePoint,
        description: this.helpWidgetForm.controls['content'].value
          ? this.helpWidgetForm.controls['content'].value
          : '-',
        page_url: location.href,
        page_name: document.title,
        browser_name: navigator.userAgent,
        media: this.media ? this.media : null,
        journey_point: this.surveyContentType,
        submitted_at: new Date(),
        name: profileData.ktpName
          ? profileData.ktpName.replace(' -', '')
          : null,
        email: profileData.emailAddress ? profileData.emailAddress : null,
        dob: profileData.dateOfBirth ? profileData.dateOfBirth : null,
        mediasource: profileData.mediasource ? profileData.mediasource : null,
        phone: profileData.mobilePhoneNumber
          ? profileData.mobilePhoneNumber
          : null,
        citizen_id: profileData.pin ? profileData.pin : null,
        education_type: profileData.educationType
          ? profileData.educationType
          : null,
        gender: profileData.gender ? profileData.gender : null,
        loanpurpose_type: profileData.loanpurpose_type
          ? profileData.loanpurpose_type
          : null,
        income_jobtype: profileData.income_jobtype
          ? profileData.income_jobtype
          : null,
        income_employmentstatus: profileData.income_employmentstatus
          ? profileData.income_employmentstatus
          : null,
        income_workposition: profileData.income_workposition
          ? profileData.income_workposition
          : null,
        domicileAddress_city: profileData.domicileAddress_city
          ? profileData.domicileAddress_city
          : null,
        contactAddress_city: profileData.contactAddress_city
          ? profileData.contactAddress_city
          : null,
        topbar_id: 1,
        version_code: '0',
        version_name: '0',
      };

      if (this.helpWidgetForm.valid) {
        this.http.post(`${this.api.apiURL}/v3/general/bantuan`, data).subscribe(
          (data: any) => {
            this.sendBusy = false;
            this.helpWidgetForm.patchValue({ content: '' });
            this.helpWidgetForm.controls['content'].markAsUntouched();
            this.helpWidgetForm.controls['content'].markAsPristine();
            this.widgetErrors.content = '';
            this.helpWidgetVisible = false;

            this.openSuccessDialog.emit(true);
          },
          (err: HttpErrorResponse) => {
            this.widgetErrors.content =
              'terjadi kesalahan, cobalah beberapa saat lagi';
            this.sendBusy = false;
          },
        );
      }
    }
  }
/**
 * @param {?} data
 * @return {?}
 */
private onChangedValues(data) {
    const /** @type {?} */ form = this.helpWidgetForm;
    const /** @type {?} */ errors = ( /** @type {?} */((<any>Object))).assign({}, this.widgetErrors);

    for (const /** @type {?} */ field in this.widgetErrors) {
      if (this.widgetErrors.hasOwnProperty(field)) {
        errors[field] = '';
        const /** @type {?} */ control = form.get(field);

        this.widgetErrors = ( /** @type {?} */((<any>Object))).assign(this.widgetErrors, errors);

        if (control && control.dirty && !control.valid) {
          for (const /** @type {?} */ key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              errors[field] = `${this.validationMessages[field][key]} `;
              this.widgetErrors = ( /** @type {?} */((<any>Object))).assign(
                this.widgetErrors,
                errors,
              );
            }
          }
        } else if (
          control &&
          control.invalid &&
          (control.value !== '' && control.value !== '0')
        ) {
          for (const /** @type {?} */ key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              errors[field] = `${this.validationMessages[field][key]} `;
              this.widgetErrors = ( /** @type {?} */((<any>Object))).assign(
                this.widgetErrors,
                errors,
              );
            }
          }
        }
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  template: `
    <div class="survey__container">
      <h1 class="survey__heading survey__heading--big">Masukan dan Saran</h1>
      <p>Bantu kami melayani Anda lebih baik.</p>
      <div class="ces">
        <h4 class="survey__heading survey__heading--medium">
          Seberapa mudah {{ surveyMessage[surveyContentType].ces }}
        </h4>
        <ul class="ces__stars">
          <li class="ces__point">
            <button
              (click)="handlePoint($event)"
              [class.active]="cesPoint === 1"
              class="point"
              value="1"
            >
              1
            </button>
            <span class="ces-text">Sangat Sulit</span>
          </li>
          <li class="ces__point">
            <button
              (click)="handlePoint($event)"
              [class.active]="cesPoint === 2"
              class="point"
              value="2"
            >
              2
            </button>
            <span class="ces-text">Cukup Sulit</span>
          </li>
          <li class="ces__point">
            <button
              (click)="handlePoint($event)"
              [class.active]="cesPoint === 3"
              class="point"
              value="3"
            >
              3
            </button>
            <span class="ces-text">Biasa Saja</span>
          </li>
          <li class="ces__point">
            <button
              (click)="handlePoint($event)"
              [class.active]="cesPoint === 4"
              class="point"
              value="4"
            >
              4
            </button>
            <span class="ces-text">Cukup Mudah</span>
          </li>
          <li class="ces__point">
            <button
              (click)="handlePoint($event)"
              [class.active]="cesPoint === 5"
              class="point"
              value="5"
            >
              5
            </button>
            <span class="ces-text">Sangat Mudah</span>
          </li>
        </ul>
      </div>

      <div class="emoscore">
        <h4 class="survey__heading survey__heading--medium">
          Apa yang anda rasakan {{ surveyMessage[surveyContentType].emo }}
        </h4>
        <p>Pilih salah satu saja</p>
        <ul class="emoscore__points">
          <li
            (click)="handlePoint($event, 'emoscore')"
            [class.active]="emoscorePoint === 13"
            class="point"
            value="13"
          >
            Khawatir
          </li>
          <li
            (click)="handlePoint($event, 'emoscore')"
            [class.active]="emoscorePoint === 16"
            class="point"
            value="16"
          >
            Antusias
          </li>
          <li
            (click)="handlePoint($event, 'emoscore')"
            [class.active]="emoscorePoint === 17"
            class="point"
            value="17"
          >
            Puas
          </li>
          <li
            (click)="handlePoint($event, 'emoscore')"
            [class.active]="emoscorePoint === 14"
            class="point"
            value="14"
          >
            Bingung
          </li>
          <li
            (click)="handlePoint($event, 'emoscore')"
            [class.active]="emoscorePoint === 15"
            class="point"
            value="15"
          >
            Nyaman
          </li>
          <li
            (click)="handlePoint($event, 'emoscore')"
            [class.active]="emoscorePoint === 12"
            class="point"
            value="12"
          >
            Kecewa
          </li>
        </ul>
      </div>

      <form class="feedback" [formGroup]="helpWidgetForm">
        <h4 class="survey__heading survey__heading--medium">
          Ceritakan alasan Anda memberikan penilaian tersebut?
        </h4>
        <div
          class="form-group"
          [ngClass]="{
            'has-success': helpWidgetForm.valid,
            'has-error': helpWidgetForm.dirty && widgetErrors.content
          }"
        >
          <textarea
            id="inp_bantuan"
            formControlName="content"
            class="form-control"
            rows="5"
            placeholder="Tulis alasan Anda disini"
          ></textarea>
          <p class="help-block">{{ widgetErrors.content }}</p>
        </div>
        <button
          type="button"
          id="btn_kirimBantuan"
          class="tnk-button tnk-button--secondary tnk-button--large"
          (click)="sendHelpWidgetForm()"
          [disabled]="emoscorePoint === 0 || cesPoint === 0"
        >
          {{ sendBusy ? 'Loading...' : 'Kirim' }}
        </button>
      </form>
    </div>
  `,
  selector: 'tnk-survey',
  styles: [`
    /*	-----------------------------------------------------------------------------

    	formare v0.1.0 | MIT License | github.com/davidkk/formare

    -----------------------------------------------------------------------------  */
    /** This project uses sanitize.css as its style resetter. */
    /*! sanitize.css v5.0.0 | CC0 License | github.com/jonathantneal/sanitize.css */
    /* Document (https://html.spec.whatwg.org/multipage/semantics.html#semantics)
    ========================================================================== */
    /**
    * 1. Remove repeating backgrounds in all browsers (opinionated).
    * 2. Add box sizing inheritence in all browsers (opinionated).
    */
    :root {
      --primary-color: #007dbc;
      --secondary-color: #81be41;
      --success-color: #48a900;
      --warning-color: #ebc500;
      --danger-color: #e85915;
      --info-color: #1C415B;
      --gray-color: #6D7A7D;
      --light-color: #e2e4e5;
      --lighter-color: #f0f2f2;
      --dark-color: #2c3132;
      --darker-color: #161819;
      --tertiary-color: #002b45;
      --font-size: 0.875rem;
      --font-family-text: -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif;
      --font-family-title: Georgia, Times New Roman, serif;
      --font-family-code: SFMono-Regular, Menlo, Monaco, Consolas, Roboto Mono, Liberation Mono, Courier New, monospace;
      --font-weight: 400;
      --text-color: #2c3132;
      --line-height: 1.5;
      --background-color: #FFFFFF; }

    *,
    ::before,
    ::after {
      background-repeat: no-repeat;
      /* 1 */
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      /* 2 */ }

    /**
    * 1. Add text decoration inheritance in all browsers (opinionated).
    * 2. Add vertical alignment inheritence in all browsers (opinionated).
    */
    ::before,
    ::after {
      text-decoration: inherit;
      /* 1 */
      vertical-align: inherit;
      /* 2 */ }

    /**
    * 1. Add border box sizing in all browsers (opinionated).
    * 2. Add the default cursor in all browsers (opinionated).
    * 3. Prevent font size adjustments after orientation changes in IE and iOS.
    */
    html {
      font-family: sans-serif;
      line-height: 1.15;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      /* 1 */
      cursor: default;
      /* 2 */
      -ms-text-size-adjust: 100%;
      /* 3 */
      -webkit-text-size-adjust: 100%;
      /* 3 */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale; }

    /* Sections (https://html.spec.whatwg.org/multipage/semantics.html#sections)
    ========================================================================== */
    /**
    * Add the correct display in IE 9-.
    */
    article,
    aside,
    footer,
    header,
    nav,
    section {
      display: block; }

    /**
    * Remove the margin in all browsers (opinionated).
    */
    body {
      margin: 0;
      font-family: var(--font-family-text);
      font-size: var(--font-size);
      font-weight: var(--font-weight);
      line-height: var(--line-height);
      color: var(--text-color);
      background-color: var(--background-color); }

    /**
    * Correct the font size and margin on \`h1\` elements within \`section\` and
    * \`article\` contexts in Chrome, Firefox, and Safari.
    */
    h1 {
      font-size: 2em;
      margin: .67em 0; }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0;
      padding: 0;
      font-size: 100%;
      font-weight: normal; }

    /* Grouping content (https://html.spec.whatwg.org/multipage/semantics.html#grouping-content)
    ========================================================================== */
    /**
    * Add the correct display in IE 9-.
    * 1. Add the correct display in IE.
    */
    figcaption,
    figure,
    main {
      /* 1 */
      display: block; }

    /**
    * Add the correct margin in IE 8.
    */
    figure {
      margin: 1em 40px; }

    /**
    * 1. Add the correct box sizing in Firefox.
    * 2. Show the overflow in Edge and IE.
    */
    hr {
      -webkit-box-sizing: content-box;
              box-sizing: content-box;
      /* 1 */
      height: 0;
      /* 1 */
      overflow: visible;
      /* 2 */ }

    /**
    * Remove the list style on navigation lists in all browsers (opinionated).
    */
    nav ol,
    nav ul {
      list-style: none;
      margin: 0;
      padding: 0; }

    /**
    * 1. Correct the inheritance and scaling of font size in all browsers.
    */
    pre {
      font-family: var(--font-family-code);
      /* 1 */
      font-size: 0.76087rem; }

    /* Text-level semantics (https://html.spec.whatwg.org/multipage/semantics.html#text-level-semantics)
    ========================================================================== */
    /**
    * 1. Remove the gray background on active links in IE 10.
    * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
    */
    a {
      text-decoration: none;
      color: inherit;
      background-color: transparent;
      /* 1 */
      -webkit-text-decoration-skip: objects;
      /* 2 */ }

    /**
    * 1. Remove the bottom border in Firefox 39-.
    * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
    */
    abbr[title] {
      border-bottom: none;
      /* 1 */
      text-decoration: underline;
      /* 2 */
      -webkit-text-decoration: underline dotted;
              text-decoration: underline dotted;
      /* 2 */ }

    /**
    * Prevent the duplicate application of \`bolder\` by the next rule in Safari 6.
    */
    b,
    strong {
      font-weight: inherit; }

    /**
    * Add the correct font weight in Chrome, Edge, and Safari.
    */
    b,
    strong {
      font-weight: bolder; }

    /**
    * 1. Correct the inheritance and scaling of font size in all browsers.
    * 2. Correct the odd \`em\` font sizing in all browsers.
    */
    code,
    kbd,
    samp {
      font-family: var(--font-family-code);
      /* 1 */
      font-size: 0.76087rem;
      /* 2 */ }

    code {
      background-color: #f0f2f2;
      color: #007dbc;
      padding: .25em;
      font-size: 0.76087rem;
      border-radius: 4px; }

    /**
    * Add the correct font style in Android 4.3-.
    */
    dfn {
      font-style: italic; }

    /**
    * Add the correct background and color in IE 9-.
    */
    mark {
      background-color: #ffff00;
      color: #000000; }

    /**
    * Add the correct font size in all browsers.
    */
    small {
      font-size: 80%; }

    /**
    * Prevent \`sub\` and \`sup\` elements from affecting the line height in
    * all browsers.
    */
    sub,
    sup {
      font-size: 75%;
      line-height: 0;
      position: relative;
      vertical-align: baseline; }

    sub {
      bottom: -.25em; }

    sup {
      top: -.5em; }

    /*
    * Remove the text shadow on text selections (opinionated).
    * 1. Restore the coloring undone by defining the text shadow (opinionated).
    */
    ::-moz-selection {
      background-color: #b3d4fc;
      /* 1 */
      color: #000000;
      /* 1 */
      text-shadow: none; }

    ::selection {
      background-color: #b3d4fc;
      /* 1 */
      color: #000000;
      /* 1 */
      text-shadow: none; }

    /* Embedded content (https://html.spec.whatwg.org/multipage/embedded-content.html#embedded-content)
    ========================================================================== */
    /*
    * Change the alignment on media elements in all browers (opinionated).
    */
    audio,
    canvas,
    iframe,
    img,
    svg,
    video {
      vertical-align: middle; }

    /**
    * Add the correct display in IE 9-.
    */
    audio,
    video {
      display: inline-block; }

    /**
    * Add the correct display in iOS 4-7.
    */
    audio:not([controls]) {
      display: none;
      height: 0; }

    /**
    * Remove the border on images inside links in IE 10-.
    */
    img {
      border-style: none; }

    /**
    * Change the fill color to match the text color in all browsers (opinionated).
    */
    svg {
      fill: currentColor; }

    /**
    * Hide the overflow in IE.
    */
    svg:not(:root) {
      overflow: hidden; }

    /* Tabular data (https://html.spec.whatwg.org/multipage/tables.html#tables)
    ========================================================================== */
    /**
    * Collapse border spacing
    */
    table {
      border-collapse: collapse; }

    /* Forms (https://html.spec.whatwg.org/multipage/forms.html#forms)
    ========================================================================== */
    /**
    * Remove the margin in Firefox and Safari.
    */
    button,
    input,
    optgroup,
    select,
    textarea {
      margin: 0; }

    /**
    * Inherit styling in all browsers (opinionated).
    */
    button,
    input,
    select,
    textarea {
      color: inherit;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit; }

    /**
    * Show the overflow in IE.
    * 1. Show the overflow in Edge.
    */
    button,
    input {
      /* 1 */
      overflow: visible; }

    /**
    * Remove the inheritance of text transform in Edge, Firefox, and IE.
    * 1. Remove the inheritance of text transform in Firefox.
    */
    button,
    select {
      /* 1 */
      text-transform: none; }

    /**
    * 1. Prevent a WebKit bug where (2) destroys native \`audio\` and \`video\`
    *    controls in Android 4.
    * 2. Correct the inability to style clickable types in iOS and Safari.
    */
    button,
    html [type="button"],
    [type="reset"],
    [type="submit"] {
      -webkit-appearance: button;
      /* 2 */ }

    /**
    * Remove the inner border and padding in Firefox.
    */
    button::-moz-focus-inner,
    [type="button"]::-moz-focus-inner,
    [type="reset"]::-moz-focus-inner,
    [type="submit"]::-moz-focus-inner {
      border-style: none;
      padding: 0; }

    /**
    * Restore the focus styles unset by the previous rule.
    */
    button:-moz-focusring,
    [type="button"]:-moz-focusring,
    [type="reset"]:-moz-focusring,
    [type="submit"]:-moz-focusring {
      outline: 1px dotted ButtonText; }

    /**
    * 1. Correct the text wrapping in Edge and IE.
    * 2. Correct the color inheritance from \`fieldset\` elements in IE.
    * 3. Remove the padding so developers are not caught out when they zero out
    *    \`fieldset\` elements in all browsers.
    */
    legend {
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      /* 1 */
      color: inherit;
      /* 2 */
      display: table;
      /* 1 */
      max-width: 100%;
      /* 1 */
      padding: 0;
      /* 3 */
      white-space: normal;
      /* 1 */ }

    /**
    * 1. Add the correct display in IE 9-.
    * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
    */
    progress {
      display: inline-block;
      /* 1 */
      vertical-align: baseline;
      /* 2 */ }

    /**
    * 1. Remove the default vertical scrollbar in IE.
    * 2. Change the resize direction on textareas in all browsers (opinionated).
    */
    textarea {
      overflow: auto;
      /* 1 */
      resize: vertical;
      /* 2 */ }

    /**
    * 1. Add the correct box sizing in IE 10-.
    * 2. Remove the padding in IE 10-.
    */
    [type="checkbox"],
    [type="radio"] {
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      /* 1 */
      padding: 0;
      /* 2 */ }

    /**
    * Correct the cursor style of increment and decrement buttons in Chrome.
    */
    [type="number"]::-webkit-inner-spin-button,
    [type="number"]::-webkit-outer-spin-button {
      height: auto; }

    /**
    * 1. Correct the odd appearance in Chrome and Safari.
    * 2. Correct the outline style in Safari.
    */
    [type="search"] {
      -webkit-appearance: textfield;
      /* 1 */
      outline-offset: -2px;
      /* 2 */ }

    /**
    * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
    */
    [type="search"]::-webkit-search-cancel-button,
    [type="search"]::-webkit-search-decoration {
      -webkit-appearance: none; }

    /**
    * 1. Correct the inability to style clickable types in iOS and Safari.
    * 2. Change font properties to \`inherit\` in Safari.
    */
    ::-webkit-file-upload-button {
      -webkit-appearance: button;
      /* 1 */
      font: inherit;
      /* 2 */ }

    /* Interactive elements (https://html.spec.whatwg.org/multipage/forms.html#interactive-elements)
    ========================================================================== */
    /*
    * Add the correct display in IE 9-.
    * 1. Add the correct display in Edge, IE, and Firefox.
    */
    details,
    menu {
      display: block; }

    /*
    * Add the correct display in all browsers.
    */
    summary {
      display: list-item; }

    /* Scripting (https://html.spec.whatwg.org/multipage/scripting.html#scripting-3)
    ========================================================================== */
    /**
    * Add the correct display in IE 9-.
    */
    canvas {
      display: inline-block; }

    /**
    * Add the correct display in IE.
    */
    template {
      display: none; }

    /* User interaction (https://html.spec.whatwg.org/multipage/interaction.html#editing)
    ========================================================================== */
    /*
    * Remove the tapping delay on clickable elements (opinionated).
    * 1. Remove the tapping delay in IE 10.
    */
    a,
    area,
    button,
    input,
    label,
    select,
    summary,
    textarea,
    [tabindex] {
      -ms-touch-action: manipulation;
      /* 1 */
      touch-action: manipulation; }

    /**
    * Add the correct display in IE 10-.
    */
    [hidden] {
      display: none; }

    /* ARIA (https://w3c.github.io/html-aria/)
    ========================================================================== */
    /**
    * Change the cursor on busy elements (opinionated).
    */
    [aria-busy="true"] {
      cursor: progress; }

    /*
    * Change the cursor on control elements (opinionated).
    */
    [aria-controls] {
      cursor: pointer; }

    /*
    * Change the display on visually hidden accessible elements (opinionated).
    */
    [aria-hidden="false"][hidden]:not(:focus) {
      clip: rect(0, 0, 0, 0);
      display: inherit;
      position: absolute; }

    /*
    * Change the cursor on disabled, not-editable, or otherwise
    * inoperable elements (opinionated).
    */
    [aria-disabled] {
      cursor: default; }

    h1,
    .heading-1 {
      font-size: 2.625rem; }

    h2,
    .heading-2 {
      font-size: 2.275rem; }

    h3,
    .heading-3 {
      font-size: 1.925rem; }

    h4,
    .heading-4 {
      font-size: 1.575rem; }

    h5,
    .heading-5 {
      font-size: 1.225rem; }

    h6,
    .heading-6 {
      font-size: 0.875rem; }

    .container {
      position: relative;
      margin: 0 auto;
      padding: 0 1rem;
      width: 100%; }
      @media (min-width: 576px) {
        .container {
          max-width: 540px;
          width: 540px; } }
      @media (min-width: 768px) {
        .container {
          max-width: 720px;
          width: 720px; } }
      @media (min-width: 992px) {
        .container {
          max-width: 960px;
          width: 960px; } }
      @media (min-width: 1200px) {
        .container {
          max-width: 1140px;
          width: 1140px; } }
      .container--fluid {
        max-width: none;
        width: 100%; }

    .row,
    .grids {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
          flex-wrap: wrap;
      margin: 0 -1rem; }
      .row--gapless,
      .grids--gapless {
        padding: 0; }
        .row--gapless .column,
        .row--gapless .grid,
        .row--gapless [class*='column-'],
        .row--gapless [class*='grid-'],
        .grids--gapless .column,
        .grids--gapless .grid,
        .grids--gapless [class*='column-'],
        .grids--gapless [class*='grid-'] {
          padding: 0; }

    .grid,
    .column {
      -webkit-box-flex: 1;
          -ms-flex-positive: 1;
              flex-grow: 1;
      -ms-flex-negative: 0;
          flex-shrink: 0;
      -ms-flex-preferred-size: 0;
          flex-basis: 0;
      max-width: 100%;
      padding: 0 1rem; }
      .grid.grid-1, .grid.column-1,
      .column.grid-1,
      .column.column-1 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 8.33333%;
            flex-basis: 8.33333%;
        max-width: 8.33333%; }
      .grid.grid-2, .grid.column-2,
      .column.grid-2,
      .column.column-2 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 16.66667%;
            flex-basis: 16.66667%;
        max-width: 16.66667%; }
      .grid.grid-3, .grid.column-3,
      .column.grid-3,
      .column.column-3 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 25%;
            flex-basis: 25%;
        max-width: 25%; }
      .grid.grid-4, .grid.column-4,
      .column.grid-4,
      .column.column-4 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 33.33333%;
            flex-basis: 33.33333%;
        max-width: 33.33333%; }
      .grid.grid-5, .grid.column-5,
      .column.grid-5,
      .column.column-5 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 41.66667%;
            flex-basis: 41.66667%;
        max-width: 41.66667%; }
      .grid.grid-6, .grid.column-6,
      .column.grid-6,
      .column.column-6 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 50%;
            flex-basis: 50%;
        max-width: 50%; }
      .grid.grid-7, .grid.column-7,
      .column.grid-7,
      .column.column-7 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 58.33333%;
            flex-basis: 58.33333%;
        max-width: 58.33333%; }
      .grid.grid-8, .grid.column-8,
      .column.grid-8,
      .column.column-8 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 66.66667%;
            flex-basis: 66.66667%;
        max-width: 66.66667%; }
      .grid.grid-9, .grid.column-9,
      .column.grid-9,
      .column.column-9 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 75%;
            flex-basis: 75%;
        max-width: 75%; }
      .grid.grid-10, .grid.column-10,
      .column.grid-10,
      .column.column-10 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 83.33333%;
            flex-basis: 83.33333%;
        max-width: 83.33333%; }
      .grid.grid-11, .grid.column-11,
      .column.grid-11,
      .column.column-11 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 91.66667%;
            flex-basis: 91.66667%;
        max-width: 91.66667%; }
      .grid.grid-12, .grid.column-12,
      .column.grid-12,
      .column.column-12 {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        -ms-flex-preferred-size: 100%;
            flex-basis: 100%;
        max-width: 100%; }
      @media (min-width: 0) {
        .grid.grid-xs, .grid.column-xs,
        .column.grid-xs,
        .column.column-xs {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 0;
              flex-basis: 0;
          max-width: 100%; }
        .grid.grid-xs-1, .grid.column-xs-1,
        .column.grid-xs-1,
        .column.column-xs-1 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 8.33333%;
              flex-basis: 8.33333%;
          max-width: 8.33333%; }
        .grid.grid-xs-2, .grid.column-xs-2,
        .column.grid-xs-2,
        .column.column-xs-2 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 16.66667%;
              flex-basis: 16.66667%;
          max-width: 16.66667%; }
        .grid.grid-xs-3, .grid.column-xs-3,
        .column.grid-xs-3,
        .column.column-xs-3 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 25%;
              flex-basis: 25%;
          max-width: 25%; }
        .grid.grid-xs-4, .grid.column-xs-4,
        .column.grid-xs-4,
        .column.column-xs-4 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 33.33333%;
              flex-basis: 33.33333%;
          max-width: 33.33333%; }
        .grid.grid-xs-5, .grid.column-xs-5,
        .column.grid-xs-5,
        .column.column-xs-5 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 41.66667%;
              flex-basis: 41.66667%;
          max-width: 41.66667%; }
        .grid.grid-xs-6, .grid.column-xs-6,
        .column.grid-xs-6,
        .column.column-xs-6 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 50%;
              flex-basis: 50%;
          max-width: 50%; }
        .grid.grid-xs-7, .grid.column-xs-7,
        .column.grid-xs-7,
        .column.column-xs-7 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 58.33333%;
              flex-basis: 58.33333%;
          max-width: 58.33333%; }
        .grid.grid-xs-8, .grid.column-xs-8,
        .column.grid-xs-8,
        .column.column-xs-8 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 66.66667%;
              flex-basis: 66.66667%;
          max-width: 66.66667%; }
        .grid.grid-xs-9, .grid.column-xs-9,
        .column.grid-xs-9,
        .column.column-xs-9 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 75%;
              flex-basis: 75%;
          max-width: 75%; }
        .grid.grid-xs-10, .grid.column-xs-10,
        .column.grid-xs-10,
        .column.column-xs-10 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 83.33333%;
              flex-basis: 83.33333%;
          max-width: 83.33333%; }
        .grid.grid-xs-11, .grid.column-xs-11,
        .column.grid-xs-11,
        .column.column-xs-11 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 91.66667%;
              flex-basis: 91.66667%;
          max-width: 91.66667%; }
        .grid.grid-xs-12, .grid.column-xs-12,
        .column.grid-xs-12,
        .column.column-xs-12 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 100%;
              flex-basis: 100%;
          max-width: 100%; } }
      @media (min-width: 576px) {
        .grid.grid-sm, .grid.column-sm,
        .column.grid-sm,
        .column.column-sm {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 0;
              flex-basis: 0;
          max-width: 100%; }
        .grid.grid-sm-1, .grid.column-sm-1,
        .column.grid-sm-1,
        .column.column-sm-1 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 8.33333%;
              flex-basis: 8.33333%;
          max-width: 8.33333%; }
        .grid.grid-sm-2, .grid.column-sm-2,
        .column.grid-sm-2,
        .column.column-sm-2 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 16.66667%;
              flex-basis: 16.66667%;
          max-width: 16.66667%; }
        .grid.grid-sm-3, .grid.column-sm-3,
        .column.grid-sm-3,
        .column.column-sm-3 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 25%;
              flex-basis: 25%;
          max-width: 25%; }
        .grid.grid-sm-4, .grid.column-sm-4,
        .column.grid-sm-4,
        .column.column-sm-4 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 33.33333%;
              flex-basis: 33.33333%;
          max-width: 33.33333%; }
        .grid.grid-sm-5, .grid.column-sm-5,
        .column.grid-sm-5,
        .column.column-sm-5 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 41.66667%;
              flex-basis: 41.66667%;
          max-width: 41.66667%; }
        .grid.grid-sm-6, .grid.column-sm-6,
        .column.grid-sm-6,
        .column.column-sm-6 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 50%;
              flex-basis: 50%;
          max-width: 50%; }
        .grid.grid-sm-7, .grid.column-sm-7,
        .column.grid-sm-7,
        .column.column-sm-7 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 58.33333%;
              flex-basis: 58.33333%;
          max-width: 58.33333%; }
        .grid.grid-sm-8, .grid.column-sm-8,
        .column.grid-sm-8,
        .column.column-sm-8 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 66.66667%;
              flex-basis: 66.66667%;
          max-width: 66.66667%; }
        .grid.grid-sm-9, .grid.column-sm-9,
        .column.grid-sm-9,
        .column.column-sm-9 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 75%;
              flex-basis: 75%;
          max-width: 75%; }
        .grid.grid-sm-10, .grid.column-sm-10,
        .column.grid-sm-10,
        .column.column-sm-10 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 83.33333%;
              flex-basis: 83.33333%;
          max-width: 83.33333%; }
        .grid.grid-sm-11, .grid.column-sm-11,
        .column.grid-sm-11,
        .column.column-sm-11 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 91.66667%;
              flex-basis: 91.66667%;
          max-width: 91.66667%; }
        .grid.grid-sm-12, .grid.column-sm-12,
        .column.grid-sm-12,
        .column.column-sm-12 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 100%;
              flex-basis: 100%;
          max-width: 100%; } }
      @media (min-width: 768px) {
        .grid.grid-md, .grid.column-md,
        .column.grid-md,
        .column.column-md {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 0;
              flex-basis: 0;
          max-width: 100%; }
        .grid.grid-md-1, .grid.column-md-1,
        .column.grid-md-1,
        .column.column-md-1 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 8.33333%;
              flex-basis: 8.33333%;
          max-width: 8.33333%; }
        .grid.grid-md-2, .grid.column-md-2,
        .column.grid-md-2,
        .column.column-md-2 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 16.66667%;
              flex-basis: 16.66667%;
          max-width: 16.66667%; }
        .grid.grid-md-3, .grid.column-md-3,
        .column.grid-md-3,
        .column.column-md-3 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 25%;
              flex-basis: 25%;
          max-width: 25%; }
        .grid.grid-md-4, .grid.column-md-4,
        .column.grid-md-4,
        .column.column-md-4 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 33.33333%;
              flex-basis: 33.33333%;
          max-width: 33.33333%; }
        .grid.grid-md-5, .grid.column-md-5,
        .column.grid-md-5,
        .column.column-md-5 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 41.66667%;
              flex-basis: 41.66667%;
          max-width: 41.66667%; }
        .grid.grid-md-6, .grid.column-md-6,
        .column.grid-md-6,
        .column.column-md-6 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 50%;
              flex-basis: 50%;
          max-width: 50%; }
        .grid.grid-md-7, .grid.column-md-7,
        .column.grid-md-7,
        .column.column-md-7 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 58.33333%;
              flex-basis: 58.33333%;
          max-width: 58.33333%; }
        .grid.grid-md-8, .grid.column-md-8,
        .column.grid-md-8,
        .column.column-md-8 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 66.66667%;
              flex-basis: 66.66667%;
          max-width: 66.66667%; }
        .grid.grid-md-9, .grid.column-md-9,
        .column.grid-md-9,
        .column.column-md-9 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 75%;
              flex-basis: 75%;
          max-width: 75%; }
        .grid.grid-md-10, .grid.column-md-10,
        .column.grid-md-10,
        .column.column-md-10 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 83.33333%;
              flex-basis: 83.33333%;
          max-width: 83.33333%; }
        .grid.grid-md-11, .grid.column-md-11,
        .column.grid-md-11,
        .column.column-md-11 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 91.66667%;
              flex-basis: 91.66667%;
          max-width: 91.66667%; }
        .grid.grid-md-12, .grid.column-md-12,
        .column.grid-md-12,
        .column.column-md-12 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 100%;
              flex-basis: 100%;
          max-width: 100%; } }
      @media (min-width: 992px) {
        .grid.grid-lg, .grid.column-lg,
        .column.grid-lg,
        .column.column-lg {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 0;
              flex-basis: 0;
          max-width: 100%; }
        .grid.grid-lg-1, .grid.column-lg-1,
        .column.grid-lg-1,
        .column.column-lg-1 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 8.33333%;
              flex-basis: 8.33333%;
          max-width: 8.33333%; }
        .grid.grid-lg-2, .grid.column-lg-2,
        .column.grid-lg-2,
        .column.column-lg-2 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 16.66667%;
              flex-basis: 16.66667%;
          max-width: 16.66667%; }
        .grid.grid-lg-3, .grid.column-lg-3,
        .column.grid-lg-3,
        .column.column-lg-3 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 25%;
              flex-basis: 25%;
          max-width: 25%; }
        .grid.grid-lg-4, .grid.column-lg-4,
        .column.grid-lg-4,
        .column.column-lg-4 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 33.33333%;
              flex-basis: 33.33333%;
          max-width: 33.33333%; }
        .grid.grid-lg-5, .grid.column-lg-5,
        .column.grid-lg-5,
        .column.column-lg-5 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 41.66667%;
              flex-basis: 41.66667%;
          max-width: 41.66667%; }
        .grid.grid-lg-6, .grid.column-lg-6,
        .column.grid-lg-6,
        .column.column-lg-6 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 50%;
              flex-basis: 50%;
          max-width: 50%; }
        .grid.grid-lg-7, .grid.column-lg-7,
        .column.grid-lg-7,
        .column.column-lg-7 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 58.33333%;
              flex-basis: 58.33333%;
          max-width: 58.33333%; }
        .grid.grid-lg-8, .grid.column-lg-8,
        .column.grid-lg-8,
        .column.column-lg-8 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 66.66667%;
              flex-basis: 66.66667%;
          max-width: 66.66667%; }
        .grid.grid-lg-9, .grid.column-lg-9,
        .column.grid-lg-9,
        .column.column-lg-9 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 75%;
              flex-basis: 75%;
          max-width: 75%; }
        .grid.grid-lg-10, .grid.column-lg-10,
        .column.grid-lg-10,
        .column.column-lg-10 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 83.33333%;
              flex-basis: 83.33333%;
          max-width: 83.33333%; }
        .grid.grid-lg-11, .grid.column-lg-11,
        .column.grid-lg-11,
        .column.column-lg-11 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 91.66667%;
              flex-basis: 91.66667%;
          max-width: 91.66667%; }
        .grid.grid-lg-12, .grid.column-lg-12,
        .column.grid-lg-12,
        .column.column-lg-12 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 100%;
              flex-basis: 100%;
          max-width: 100%; } }
      @media (min-width: 1200px) {
        .grid.grid-xl, .grid.column-xl,
        .column.grid-xl,
        .column.column-xl {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 0;
              flex-basis: 0;
          max-width: 100%; }
        .grid.grid-xl-1, .grid.column-xl-1,
        .column.grid-xl-1,
        .column.column-xl-1 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 8.33333%;
              flex-basis: 8.33333%;
          max-width: 8.33333%; }
        .grid.grid-xl-2, .grid.column-xl-2,
        .column.grid-xl-2,
        .column.column-xl-2 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 16.66667%;
              flex-basis: 16.66667%;
          max-width: 16.66667%; }
        .grid.grid-xl-3, .grid.column-xl-3,
        .column.grid-xl-3,
        .column.column-xl-3 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 25%;
              flex-basis: 25%;
          max-width: 25%; }
        .grid.grid-xl-4, .grid.column-xl-4,
        .column.grid-xl-4,
        .column.column-xl-4 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 33.33333%;
              flex-basis: 33.33333%;
          max-width: 33.33333%; }
        .grid.grid-xl-5, .grid.column-xl-5,
        .column.grid-xl-5,
        .column.column-xl-5 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 41.66667%;
              flex-basis: 41.66667%;
          max-width: 41.66667%; }
        .grid.grid-xl-6, .grid.column-xl-6,
        .column.grid-xl-6,
        .column.column-xl-6 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 50%;
              flex-basis: 50%;
          max-width: 50%; }
        .grid.grid-xl-7, .grid.column-xl-7,
        .column.grid-xl-7,
        .column.column-xl-7 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 58.33333%;
              flex-basis: 58.33333%;
          max-width: 58.33333%; }
        .grid.grid-xl-8, .grid.column-xl-8,
        .column.grid-xl-8,
        .column.column-xl-8 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 66.66667%;
              flex-basis: 66.66667%;
          max-width: 66.66667%; }
        .grid.grid-xl-9, .grid.column-xl-9,
        .column.grid-xl-9,
        .column.column-xl-9 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 75%;
              flex-basis: 75%;
          max-width: 75%; }
        .grid.grid-xl-10, .grid.column-xl-10,
        .column.grid-xl-10,
        .column.column-xl-10 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 83.33333%;
              flex-basis: 83.33333%;
          max-width: 83.33333%; }
        .grid.grid-xl-11, .grid.column-xl-11,
        .column.grid-xl-11,
        .column.column-xl-11 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 91.66667%;
              flex-basis: 91.66667%;
          max-width: 91.66667%; }
        .grid.grid-xl-12, .grid.column-xl-12,
        .column.grid-xl-12,
        .column.column-xl-12 {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          -ms-flex-negative: 0;
              flex-shrink: 0;
          -ms-flex-preferred-size: 100%;
              flex-basis: 100%;
          max-width: 100%; } }

    .structure {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
          -ms-flex-direction: column;
              flex-direction: column;
      -webkit-box-flex: 1;
          -ms-flex: 1 1 100%;
              flex: 1 1 100%;
      min-width: 0; }
      .structure--horizontal {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row; }

    .section {
      position: relative; }
      .section--primary {
        background-color: #007dbc;
        color: #f0f2f2; }
      .section--secondary {
        background-color: #81be41;
        color: #f0f2f2; }
      .section--success {
        background-color: #48a900;
        color: #f0f2f2; }
      .section--warning {
        background-color: #ebc500;
        color: #f0f2f2; }
      .section--danger {
        background-color: #e85915;
        color: #f0f2f2; }
      .section--info {
        background-color: #1C415B;
        color: #f0f2f2; }
      .section--gray {
        background-color: #6D7A7D;
        color: #f0f2f2; }
      .section--light {
        background-color: #e2e4e5;
        color: #2c3132; }
      .section--lighter {
        background-color: #f0f2f2;
        color: #2c3132; }
      .section--dark {
        background-color: #2c3132;
        color: #f0f2f2; }
      .section--darker {
        background-color: #161819;
        color: #f0f2f2; }
      .section--tertiary {
        background-color: #002b45;
        color: #f0f2f2; }

    .hero {
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
          -ms-flex-direction: column;
              flex-direction: column;
      min-height: 25em; }
      .hero__bg {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 250;
        background-position: center;
        background-size: cover; }
      .hero__body {
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        height: 100%;
        padding-top: 2rem;
        padding-bottom: 2rem; }
        .hero__body--centerized {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
              -ms-flex-align: center;
                  align-items: center;
          -webkit-box-pack: center;
              -ms-flex-pack: center;
                  justify-content: center; }
      .hero > *:not(.hero__bg), .hero__body {
        position: relative;
        z-index: 500; }
      .hero--x-small {
        min-height: 12.5em; }
      .hero--small {
        min-height: 18.75em; }
      .hero--normal {
        min-height: 25em; }
      .hero--large {
        min-height: 37.5em; }
      .hero--x-large {
        min-height: 50em; }
      .hero--primary {
        background-color: #007dbc;
        color: #f0f2f2; }
        .hero--primary .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #007dbc;
          opacity: 0.7; }
      .hero--secondary {
        background-color: #81be41;
        color: #f0f2f2; }
        .hero--secondary .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #81be41;
          opacity: 0.7; }
      .hero--success {
        background-color: #48a900;
        color: #f0f2f2; }
        .hero--success .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #48a900;
          opacity: 0.7; }
      .hero--warning {
        background-color: #ebc500;
        color: #f0f2f2; }
        .hero--warning .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #ebc500;
          opacity: 0.7; }
      .hero--danger {
        background-color: #e85915;
        color: #f0f2f2; }
        .hero--danger .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #e85915;
          opacity: 0.7; }
      .hero--info {
        background-color: #1C415B;
        color: #f0f2f2; }
        .hero--info .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #1C415B;
          opacity: 0.7; }
      .hero--gray {
        background-color: #6D7A7D;
        color: #f0f2f2; }
        .hero--gray .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #6D7A7D;
          opacity: 0.7; }
      .hero--light {
        background-color: #e2e4e5;
        color: #2c3132; }
        .hero--light .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #e2e4e5;
          opacity: 0.7; }
      .hero--lighter {
        background-color: #f0f2f2;
        color: #2c3132; }
        .hero--lighter .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #f0f2f2;
          opacity: 0.7; }
      .hero--dark {
        background-color: #2c3132;
        color: #f0f2f2; }
        .hero--dark .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #2c3132;
          opacity: 0.7; }
      .hero--darker {
        background-color: #161819;
        color: #f0f2f2; }
        .hero--darker .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #161819;
          opacity: 0.7; }
      .hero--tertiary {
        background-color: #002b45;
        color: #f0f2f2; }
        .hero--tertiary .hero__bg:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #002b45;
          opacity: 0.7; }
      .hero--full-height {
        height: 100vh;
        min-height: 100vh; }

    .flex {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex; }
      .flex--inline {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex; }
      .flex--row {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row; }
      .flex--column {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column; }

    .jc-start,
    .justify-content-start {
      -webkit-box-pack: start;
          -ms-flex-pack: start;
              justify-content: flex-start; }

    .jc-center,
    .justify-content-center {
      -webkit-box-pack: center;
          -ms-flex-pack: center;
              justify-content: center; }

    .jc-end,
    .justify-content-end {
      -webkit-box-pack: end;
          -ms-flex-pack: end;
              justify-content: flex-end; }

    .jc-between,
    .justify-content-between {
      -webkit-box-pack: justify;
          -ms-flex-pack: justify;
              justify-content: space-between; }

    .jc-around,
    .justify-content-around {
      -ms-flex-pack: distribute;
          justify-content: space-around; }

    .jc-evenly,
    .justify-content-evenly {
      -webkit-box-pack: space-evenly;
          -ms-flex-pack: space-evenly;
              justify-content: space-evenly; }

    .ai-start,
    .align-items-start {
      -webkit-box-align: start;
          -ms-flex-align: start;
              align-items: flex-start; }

    .ai-center,
    .align-items-center {
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center; }

    .ai-end,
    .align-items-end {
      -webkit-box-align: end;
          -ms-flex-align: end;
              align-items: flex-end; }

    .ai-stretch,
    .align-items-stretch {
      -webkit-box-align: stretch;
          -ms-flex-align: stretch;
              align-items: stretch; }

    .ai-baseline,
    .align-items-baseline {
      -webkit-box-align: baseline;
          -ms-flex-align: baseline;
              align-items: baseline; }

    .form__label {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      font-weight: 500;
      margin-bottom: 0.57143rem; }

    .form__field {
      margin-bottom: 1rem; }
      .form__field--primary.form__label {
        color: #007dbc; }
      .form__field--primary.form .input,
      .form__field--primary.form .select,
      .form__field--primary.form .textarea {
        border-color: #007dbc; }
        .form__field--primary.form .input:hover,
        .form__field--primary.form .select:hover,
        .form__field--primary.form .textarea:hover {
          border-color: #007dbc; }
        .form__field--primary.form .input:focus,
        .form__field--primary.form .select:focus,
        .form__field--primary.form .textarea:focus {
          border-color: #007dbc;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(0, 125, 188, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(0, 125, 188, 0.3); }
      .form__field--secondary.form__label {
        color: #81be41; }
      .form__field--secondary.form .input,
      .form__field--secondary.form .select,
      .form__field--secondary.form .textarea {
        border-color: #81be41; }
        .form__field--secondary.form .input:hover,
        .form__field--secondary.form .select:hover,
        .form__field--secondary.form .textarea:hover {
          border-color: #81be41; }
        .form__field--secondary.form .input:focus,
        .form__field--secondary.form .select:focus,
        .form__field--secondary.form .textarea:focus {
          border-color: #81be41;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(129, 190, 65, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(129, 190, 65, 0.3); }
      .form__field--success.form__label {
        color: #48a900; }
      .form__field--success.form .input,
      .form__field--success.form .select,
      .form__field--success.form .textarea {
        border-color: #48a900; }
        .form__field--success.form .input:hover,
        .form__field--success.form .select:hover,
        .form__field--success.form .textarea:hover {
          border-color: #48a900; }
        .form__field--success.form .input:focus,
        .form__field--success.form .select:focus,
        .form__field--success.form .textarea:focus {
          border-color: #48a900;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(72, 169, 0, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(72, 169, 0, 0.3); }
      .form__field--warning.form__label {
        color: #ebc500; }
      .form__field--warning.form .input,
      .form__field--warning.form .select,
      .form__field--warning.form .textarea {
        border-color: #ebc500; }
        .form__field--warning.form .input:hover,
        .form__field--warning.form .select:hover,
        .form__field--warning.form .textarea:hover {
          border-color: #ebc500; }
        .form__field--warning.form .input:focus,
        .form__field--warning.form .select:focus,
        .form__field--warning.form .textarea:focus {
          border-color: #ebc500;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(235, 197, 0, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(235, 197, 0, 0.3); }
      .form__field--danger.form__label {
        color: #e85915; }
      .form__field--danger.form .input,
      .form__field--danger.form .select,
      .form__field--danger.form .textarea {
        border-color: #e85915; }
        .form__field--danger.form .input:hover,
        .form__field--danger.form .select:hover,
        .form__field--danger.form .textarea:hover {
          border-color: #e85915; }
        .form__field--danger.form .input:focus,
        .form__field--danger.form .select:focus,
        .form__field--danger.form .textarea:focus {
          border-color: #e85915;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(232, 89, 21, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(232, 89, 21, 0.3); }
      .form__field--info.form__label {
        color: #1C415B; }
      .form__field--info.form .input,
      .form__field--info.form .select,
      .form__field--info.form .textarea {
        border-color: #1C415B; }
        .form__field--info.form .input:hover,
        .form__field--info.form .select:hover,
        .form__field--info.form .textarea:hover {
          border-color: #1C415B; }
        .form__field--info.form .input:focus,
        .form__field--info.form .select:focus,
        .form__field--info.form .textarea:focus {
          border-color: #1C415B;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(28, 65, 91, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(28, 65, 91, 0.3); }
      .form__field--gray.form__label {
        color: #6D7A7D; }
      .form__field--gray.form .input,
      .form__field--gray.form .select,
      .form__field--gray.form .textarea {
        border-color: #6D7A7D; }
        .form__field--gray.form .input:hover,
        .form__field--gray.form .select:hover,
        .form__field--gray.form .textarea:hover {
          border-color: #6D7A7D; }
        .form__field--gray.form .input:focus,
        .form__field--gray.form .select:focus,
        .form__field--gray.form .textarea:focus {
          border-color: #6D7A7D;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(109, 122, 125, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(109, 122, 125, 0.3); }
      .form__field--light.form__label {
        color: #e2e4e5; }
      .form__field--light.form .input,
      .form__field--light.form .select,
      .form__field--light.form .textarea {
        border-color: #e2e4e5; }
        .form__field--light.form .input:hover,
        .form__field--light.form .select:hover,
        .form__field--light.form .textarea:hover {
          border-color: #e2e4e5; }
        .form__field--light.form .input:focus,
        .form__field--light.form .select:focus,
        .form__field--light.form .textarea:focus {
          border-color: #e2e4e5;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(226, 228, 229, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(226, 228, 229, 0.3); }
      .form__field--lighter.form__label {
        color: #f0f2f2; }
      .form__field--lighter.form .input,
      .form__field--lighter.form .select,
      .form__field--lighter.form .textarea {
        border-color: #f0f2f2; }
        .form__field--lighter.form .input:hover,
        .form__field--lighter.form .select:hover,
        .form__field--lighter.form .textarea:hover {
          border-color: #f0f2f2; }
        .form__field--lighter.form .input:focus,
        .form__field--lighter.form .select:focus,
        .form__field--lighter.form .textarea:focus {
          border-color: #f0f2f2;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(240, 242, 242, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(240, 242, 242, 0.3); }
      .form__field--dark.form__label {
        color: #2c3132; }
      .form__field--dark.form .input,
      .form__field--dark.form .select,
      .form__field--dark.form .textarea {
        border-color: #2c3132; }
        .form__field--dark.form .input:hover,
        .form__field--dark.form .select:hover,
        .form__field--dark.form .textarea:hover {
          border-color: #2c3132; }
        .form__field--dark.form .input:focus,
        .form__field--dark.form .select:focus,
        .form__field--dark.form .textarea:focus {
          border-color: #2c3132;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(44, 49, 50, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(44, 49, 50, 0.3); }
      .form__field--darker.form__label {
        color: #161819; }
      .form__field--darker.form .input,
      .form__field--darker.form .select,
      .form__field--darker.form .textarea {
        border-color: #161819; }
        .form__field--darker.form .input:hover,
        .form__field--darker.form .select:hover,
        .form__field--darker.form .textarea:hover {
          border-color: #161819; }
        .form__field--darker.form .input:focus,
        .form__field--darker.form .select:focus,
        .form__field--darker.form .textarea:focus {
          border-color: #161819;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(22, 24, 25, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(22, 24, 25, 0.3); }
      .form__field--tertiary.form__label {
        color: #002b45; }
      .form__field--tertiary.form .input,
      .form__field--tertiary.form .select,
      .form__field--tertiary.form .textarea {
        border-color: #002b45; }
        .form__field--tertiary.form .input:hover,
        .form__field--tertiary.form .select:hover,
        .form__field--tertiary.form .textarea:hover {
          border-color: #002b45; }
        .form__field--tertiary.form .input:focus,
        .form__field--tertiary.form .select:focus,
        .form__field--tertiary.form .textarea:focus {
          border-color: #002b45;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(0, 43, 69, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(0, 43, 69, 0.3); }

    .form__control {
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
          -ms-flex-direction: row;
              flex-direction: row;
      width: 100%; }
      .form__control > *:hover {
        z-index: 2; }
      .form__control > *:not(:last-child) {
        margin-right: -1px; }
      .form__control > *:first-child:not(:last-child),
      .form__control > .select:first-child:not(:last-child) > select {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0; }
      .form__control > *:not(:first-child):not(:last-child),
      .form__control > .select:not(:first-child):not(:last-child) > select {
        border-radius: 0; }
      .form__control > *:last-child:not(:first-child),
      .form__control > .select:last-child:not(:first-child) > select {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0; }

    .alert {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
      position: relative;
      border-radius: 4px;
      background-color: #f5e280;
      color: #b09400; }
      .alert--primary {
        background-color: #80bede;
        color: #005e8d; }
      .alert--secondary {
        background-color: #c0dfa0;
        color: #618f31; }
      .alert--success {
        background-color: #a4d480;
        color: #367f00; }
      .alert--warning {
        background-color: #f5e280;
        color: #b09400; }
      .alert--danger {
        background-color: #f4ac8a;
        color: #ae4310; }
      .alert--info {
        background-color: #8ea0ad;
        color: #153144; }
      .alert--gray {
        background-color: #b6bdbe;
        color: #525c5e; }
      .alert--light {
        background-color: #f1f2f2;
        color: #aaabac; }
      .alert--lighter {
        background-color: #f8f9f9;
        color: #b4b6b6; }
      .alert--dark {
        background-color: #969899;
        color: #212526; }
      .alert--darker {
        background-color: #8b8c8c;
        color: #111213; }
      .alert--tertiary {
        background-color: #8095a2;
        color: #002034; }
      .alert > * {
        padding-top: 1rem;
        padding-bottom: 1rem; }
      .alert__body,
      .alert > *:not(.alert__icon) {
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        padding-left: 1.5rem;
        padding-right: 1.5rem; }
      .alert__icon:first-child {
        padding-left: 1rem; }
      .alert__icon:last-child {
        padding-right: 1rem; }

    .article {
      position: relative; }
      .article .heading {
        margin-bottom: 1rem; }

    .title {
      font-weight: 700; }

    .subtitle {
      font-weight: 400; }

    .nav {
      position: relative; }
      .nav__list {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row; }
      .nav__item {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        font-weight: 500;
        padding-left: 1rem;
        padding-right: 1rem; }
      .nav__link {
        display: block;
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        padding: 1rem;
        margin-left: -1rem;
        margin-right: -1rem; }
        .nav__link:hover {
          cursor: pointer;
          color: #007dbc; }

    .navbar {
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
          -ms-flex-pack: justify;
              justify-content: space-between;
      height: 4em;
      min-height: 4em;
      -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
      transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
      background: #f0f2f2; }
      .navbar__block {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        height: 100%; }
        .navbar__block--expanded {
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1; }
        .navbar__block:not(:first-child):not(:only-child) {
          padding-left: 0.8rem; }
        .navbar__block:not(:last-child):not(:only-child) {
          padding-right: 0.8rem; }
        .navbar__block--start {
          -webkit-box-pack: start;
              -ms-flex-pack: start;
                  justify-content: flex-start; }
        .navbar__block--center {
          -webkit-box-pack: center;
              -ms-flex-pack: center;
                  justify-content: center; }
        .navbar__block--end {
          -webkit-box-pack: end;
              -ms-flex-pack: end;
                  justify-content: flex-end; }
      .navbar .nav {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 100%; }
        .navbar .nav .nav__link {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          height: 100%;
          -webkit-box-align: center;
              -ms-flex-align: center;
                  align-items: center;
          padding-top: 0;
          padding-bottom: 0;
          color: #2c3132; }
          .navbar .nav .nav__link:hover {
            color: #007dbc; }
      .navbar--primary {
        background-color: #007dbc;
        color: #f0f2f2; }
        .navbar--primary .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(240, 242, 242, 0.7); }
          .navbar--primary .nav .nav__link:hover {
            color: #f0f2f2; }
      .navbar--secondary {
        background-color: #81be41;
        color: #f0f2f2; }
        .navbar--secondary .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(240, 242, 242, 0.7); }
          .navbar--secondary .nav .nav__link:hover {
            color: #f0f2f2; }
      .navbar--success {
        background-color: #48a900;
        color: #f0f2f2; }
        .navbar--success .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(240, 242, 242, 0.7); }
          .navbar--success .nav .nav__link:hover {
            color: #f0f2f2; }
      .navbar--warning {
        background-color: #ebc500;
        color: #f0f2f2; }
        .navbar--warning .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(240, 242, 242, 0.7); }
          .navbar--warning .nav .nav__link:hover {
            color: #f0f2f2; }
      .navbar--danger {
        background-color: #e85915;
        color: #f0f2f2; }
        .navbar--danger .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(240, 242, 242, 0.7); }
          .navbar--danger .nav .nav__link:hover {
            color: #f0f2f2; }
      .navbar--info {
        background-color: #1C415B;
        color: #f0f2f2; }
        .navbar--info .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(240, 242, 242, 0.7); }
          .navbar--info .nav .nav__link:hover {
            color: #f0f2f2; }
      .navbar--gray {
        background-color: #6D7A7D;
        color: #f0f2f2; }
        .navbar--gray .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(240, 242, 242, 0.7); }
          .navbar--gray .nav .nav__link:hover {
            color: #f0f2f2; }
      .navbar--light {
        background-color: #e2e4e5;
        color: #2c3132; }
        .navbar--light .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(44, 49, 50, 0.7); }
          .navbar--light .nav .nav__link:hover {
            color: #2c3132; }
      .navbar--lighter {
        background-color: #f0f2f2;
        color: #2c3132; }
        .navbar--lighter .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(44, 49, 50, 0.7); }
          .navbar--lighter .nav .nav__link:hover {
            color: #2c3132; }
      .navbar--dark {
        background-color: #2c3132;
        color: #f0f2f2; }
        .navbar--dark .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(240, 242, 242, 0.7); }
          .navbar--dark .nav .nav__link:hover {
            color: #f0f2f2; }
      .navbar--darker {
        background-color: #161819;
        color: #f0f2f2; }
        .navbar--darker .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(240, 242, 242, 0.7); }
          .navbar--darker .nav .nav__link:hover {
            color: #f0f2f2; }
      .navbar--tertiary {
        background-color: #002b45;
        color: #f0f2f2; }
        .navbar--tertiary .nav .nav__link {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          color: rgba(240, 242, 242, 0.7); }
          .navbar--tertiary .nav .nav__link:hover {
            color: #f0f2f2; }
      .navbar--x-small {
        height: 2em;
        min-height: 2em; }
      .navbar--small {
        height: 3em;
        min-height: 3em; }
      .navbar--base {
        height: 4em;
        min-height: 4em; }
      .navbar--large {
        height: 6em;
        min-height: 6em; }
      .navbar--x-large {
        height: 8em;
        min-height: 8em; }

    .button {
      position: relative;
      font-weight: 500;
      padding: 0.5em 1em;
      background-color: #FFFFFF;
      border-style: solid;
      border-width: 1px;
      border-color: #d3d7d8;
      border-radius: 4px;
      -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
      transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
      color: #2c3132;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      outline: none;
      cursor: pointer; }
      .button:hover:not(:disabled), .button--hovered:not(:disabled) {
        color: #007dbc;
        border-color: #007dbc;
        outline: none; }
      .button:focus:not(:disabled):not(.button--clear), .button--focused:not(:disabled):not(.button--clear) {
        color: #3397c9;
        border-color: #3397c9;
        -webkit-box-shadow: 0 0 0.3em 0.2em rgba(38, 145, 198, 0.3);
                box-shadow: 0 0 0.3em 0.2em rgba(38, 145, 198, 0.3);
        outline: none; }
      .button:active:not(:disabled), .button--active:not(:disabled) {
        color: #004b71;
        border-color: #004b71;
        outline: none; }
      .button:disabled, .button--disabled {
        opacity: 0.5;
        cursor: not-allowed; }
      .button--primary {
        background-color: #007dbc;
        color: #f0f2f2;
        border-color: #007dbc; }
        .button--primary:hover:not(:disabled), .button--primary.button--hovered:not(:disabled) {
          color: #f0f2f2;
          background-color: #3397c9;
          border-color: #3397c9; }
        .button--primary:focus:not(:disabled):not(.button--clear), .button--primary.button--focused:not(:disabled) {
          color: #f0f2f2;
          background-color: #3397c9;
          border-color: #3397c9;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(0, 125, 188, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(0, 125, 188, 0.3); }
        .button--primary:active:not(:disabled):not(.button--clear), .button--primary.button--active:not(:disabled) {
          color: #f0f2f2;
          background-color: #006496;
          border-color: #006496; }
        .button--primary.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #0071a9; }
        .button--primary.button--raised:hover:not(:disabled), .button--primary.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #007dbc; }
        .button--primary.button--raised:focus:not(:disabled), .button--primary.button--raised.button--focus:not(:disabled) {
          border-color: #1a8ac3;
          border-bottom-width: 4px;
          border-bottom-color: #0071a9;
          background-color: #1a8ac3;
          margin-top: 0px;
          outline: none; }
        .button--primary.button--raised:active:not(:disabled), .button--primary.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #006496;
          background-color: #006496;
          margin-top: 3px;
          outline: none; }
        .button--primary.button--outlined {
          color: #007dbc;
          background-color: transparent; }
          .button--primary.button--outlined:hover:not(:disabled), .button--primary.button--outlined.button--hovered:not(:disabled) {
            color: #f0f2f2;
            background-color: #1a8ac3;
            border-color: #1a8ac3; }
          .button--primary.button--outlined:focus:not(:disabled), .button--primary.button--outlined.button--focused:not(:disabled) {
            color: #f0f2f2;
            background-color: #1a8ac3;
            border-color: #1a8ac3;
            outline: none; }
          .button--primary.button--outlined:active:not(:disabled), .button--primary.button--outlined.button--active:not(:disabled) {
            color: #f0f2f2;
            background-color: #006496;
            border-color: #006496; }
      .button--secondary {
        background-color: #81be41;
        color: #f0f2f2;
        border-color: #81be41; }
        .button--secondary:hover:not(:disabled), .button--secondary.button--hovered:not(:disabled) {
          color: #f0f2f2;
          background-color: #9acb67;
          border-color: #9acb67; }
        .button--secondary:focus:not(:disabled):not(.button--clear), .button--secondary.button--focused:not(:disabled) {
          color: #f0f2f2;
          background-color: #9acb67;
          border-color: #9acb67;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(129, 190, 65, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(129, 190, 65, 0.3); }
        .button--secondary:active:not(:disabled):not(.button--clear), .button--secondary.button--active:not(:disabled) {
          color: #f0f2f2;
          background-color: #679834;
          border-color: #679834; }
        .button--secondary.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #74ab3b; }
        .button--secondary.button--raised:hover:not(:disabled), .button--secondary.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #81be41; }
        .button--secondary.button--raised:focus:not(:disabled), .button--secondary.button--raised.button--focus:not(:disabled) {
          border-color: #8ec554;
          border-bottom-width: 4px;
          border-bottom-color: #74ab3b;
          background-color: #8ec554;
          margin-top: 0px;
          outline: none; }
        .button--secondary.button--raised:active:not(:disabled), .button--secondary.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #679834;
          background-color: #679834;
          margin-top: 3px;
          outline: none; }
        .button--secondary.button--outlined {
          color: #81be41;
          background-color: transparent; }
          .button--secondary.button--outlined:hover:not(:disabled), .button--secondary.button--outlined.button--hovered:not(:disabled) {
            color: #f0f2f2;
            background-color: #8ec554;
            border-color: #8ec554; }
          .button--secondary.button--outlined:focus:not(:disabled), .button--secondary.button--outlined.button--focused:not(:disabled) {
            color: #f0f2f2;
            background-color: #8ec554;
            border-color: #8ec554;
            outline: none; }
          .button--secondary.button--outlined:active:not(:disabled), .button--secondary.button--outlined.button--active:not(:disabled) {
            color: #f0f2f2;
            background-color: #679834;
            border-color: #679834; }
      .button--success {
        background-color: #48a900;
        color: #f0f2f2;
        border-color: #48a900; }
        .button--success:hover:not(:disabled), .button--success.button--hovered:not(:disabled) {
          color: #f0f2f2;
          background-color: #6dba33;
          border-color: #6dba33; }
        .button--success:focus:not(:disabled):not(.button--clear), .button--success.button--focused:not(:disabled) {
          color: #f0f2f2;
          background-color: #6dba33;
          border-color: #6dba33;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(72, 169, 0, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(72, 169, 0, 0.3); }
        .button--success:active:not(:disabled):not(.button--clear), .button--success.button--active:not(:disabled) {
          color: #f0f2f2;
          background-color: #3a8700;
          border-color: #3a8700; }
        .button--success.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #419800; }
        .button--success.button--raised:hover:not(:disabled), .button--success.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #48a900; }
        .button--success.button--raised:focus:not(:disabled), .button--success.button--raised.button--focus:not(:disabled) {
          border-color: #5ab21a;
          border-bottom-width: 4px;
          border-bottom-color: #419800;
          background-color: #5ab21a;
          margin-top: 0px;
          outline: none; }
        .button--success.button--raised:active:not(:disabled), .button--success.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #3a8700;
          background-color: #3a8700;
          margin-top: 3px;
          outline: none; }
        .button--success.button--outlined {
          color: #48a900;
          background-color: transparent; }
          .button--success.button--outlined:hover:not(:disabled), .button--success.button--outlined.button--hovered:not(:disabled) {
            color: #f0f2f2;
            background-color: #5ab21a;
            border-color: #5ab21a; }
          .button--success.button--outlined:focus:not(:disabled), .button--success.button--outlined.button--focused:not(:disabled) {
            color: #f0f2f2;
            background-color: #5ab21a;
            border-color: #5ab21a;
            outline: none; }
          .button--success.button--outlined:active:not(:disabled), .button--success.button--outlined.button--active:not(:disabled) {
            color: #f0f2f2;
            background-color: #3a8700;
            border-color: #3a8700; }
      .button--warning {
        background-color: #ebc500;
        color: #f0f2f2;
        border-color: #ebc500; }
        .button--warning:hover:not(:disabled), .button--warning.button--hovered:not(:disabled) {
          color: #f0f2f2;
          background-color: #efd133;
          border-color: #efd133; }
        .button--warning:focus:not(:disabled):not(.button--clear), .button--warning.button--focused:not(:disabled) {
          color: #f0f2f2;
          background-color: #efd133;
          border-color: #efd133;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(235, 197, 0, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(235, 197, 0, 0.3); }
        .button--warning:active:not(:disabled):not(.button--clear), .button--warning.button--active:not(:disabled) {
          color: #f0f2f2;
          background-color: #bc9e00;
          border-color: #bc9e00; }
        .button--warning.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #d4b100; }
        .button--warning.button--raised:hover:not(:disabled), .button--warning.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #ebc500; }
        .button--warning.button--raised:focus:not(:disabled), .button--warning.button--raised.button--focus:not(:disabled) {
          border-color: #edcb1a;
          border-bottom-width: 4px;
          border-bottom-color: #d4b100;
          background-color: #edcb1a;
          margin-top: 0px;
          outline: none; }
        .button--warning.button--raised:active:not(:disabled), .button--warning.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #bc9e00;
          background-color: #bc9e00;
          margin-top: 3px;
          outline: none; }
        .button--warning.button--outlined {
          color: #ebc500;
          background-color: transparent; }
          .button--warning.button--outlined:hover:not(:disabled), .button--warning.button--outlined.button--hovered:not(:disabled) {
            color: #f0f2f2;
            background-color: #edcb1a;
            border-color: #edcb1a; }
          .button--warning.button--outlined:focus:not(:disabled), .button--warning.button--outlined.button--focused:not(:disabled) {
            color: #f0f2f2;
            background-color: #edcb1a;
            border-color: #edcb1a;
            outline: none; }
          .button--warning.button--outlined:active:not(:disabled), .button--warning.button--outlined.button--active:not(:disabled) {
            color: #f0f2f2;
            background-color: #bc9e00;
            border-color: #bc9e00; }
      .button--danger {
        background-color: #e85915;
        color: #f0f2f2;
        border-color: #e85915; }
        .button--danger:hover:not(:disabled), .button--danger.button--hovered:not(:disabled) {
          color: #f0f2f2;
          background-color: #ed7a44;
          border-color: #ed7a44; }
        .button--danger:focus:not(:disabled):not(.button--clear), .button--danger.button--focused:not(:disabled) {
          color: #f0f2f2;
          background-color: #ed7a44;
          border-color: #ed7a44;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(232, 89, 21, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(232, 89, 21, 0.3); }
        .button--danger:active:not(:disabled):not(.button--clear), .button--danger.button--active:not(:disabled) {
          color: #f0f2f2;
          background-color: #ba4711;
          border-color: #ba4711; }
        .button--danger.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #d15013; }
        .button--danger.button--raised:hover:not(:disabled), .button--danger.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #e85915; }
        .button--danger.button--raised:focus:not(:disabled), .button--danger.button--raised.button--focus:not(:disabled) {
          border-color: #ea6a2c;
          border-bottom-width: 4px;
          border-bottom-color: #d15013;
          background-color: #ea6a2c;
          margin-top: 0px;
          outline: none; }
        .button--danger.button--raised:active:not(:disabled), .button--danger.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #ba4711;
          background-color: #ba4711;
          margin-top: 3px;
          outline: none; }
        .button--danger.button--outlined {
          color: #e85915;
          background-color: transparent; }
          .button--danger.button--outlined:hover:not(:disabled), .button--danger.button--outlined.button--hovered:not(:disabled) {
            color: #f0f2f2;
            background-color: #ea6a2c;
            border-color: #ea6a2c; }
          .button--danger.button--outlined:focus:not(:disabled), .button--danger.button--outlined.button--focused:not(:disabled) {
            color: #f0f2f2;
            background-color: #ea6a2c;
            border-color: #ea6a2c;
            outline: none; }
          .button--danger.button--outlined:active:not(:disabled), .button--danger.button--outlined.button--active:not(:disabled) {
            color: #f0f2f2;
            background-color: #ba4711;
            border-color: #ba4711; }
      .button--info {
        background-color: #1C415B;
        color: #f0f2f2;
        border-color: #1C415B; }
        .button--info:hover:not(:disabled), .button--info.button--hovered:not(:disabled) {
          color: #f0f2f2;
          background-color: #49677c;
          border-color: #49677c; }
        .button--info:focus:not(:disabled):not(.button--clear), .button--info.button--focused:not(:disabled) {
          color: #f0f2f2;
          background-color: #49677c;
          border-color: #49677c;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(28, 65, 91, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(28, 65, 91, 0.3); }
        .button--info:active:not(:disabled):not(.button--clear), .button--info.button--active:not(:disabled) {
          color: #f0f2f2;
          background-color: #163449;
          border-color: #163449; }
        .button--info.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #193b52; }
        .button--info.button--raised:hover:not(:disabled), .button--info.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #1C415B; }
        .button--info.button--raised:focus:not(:disabled), .button--info.button--raised.button--focus:not(:disabled) {
          border-color: #33546b;
          border-bottom-width: 4px;
          border-bottom-color: #193b52;
          background-color: #33546b;
          margin-top: 0px;
          outline: none; }
        .button--info.button--raised:active:not(:disabled), .button--info.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #163449;
          background-color: #163449;
          margin-top: 3px;
          outline: none; }
        .button--info.button--outlined {
          color: #1C415B;
          background-color: transparent; }
          .button--info.button--outlined:hover:not(:disabled), .button--info.button--outlined.button--hovered:not(:disabled) {
            color: #f0f2f2;
            background-color: #33546b;
            border-color: #33546b; }
          .button--info.button--outlined:focus:not(:disabled), .button--info.button--outlined.button--focused:not(:disabled) {
            color: #f0f2f2;
            background-color: #33546b;
            border-color: #33546b;
            outline: none; }
          .button--info.button--outlined:active:not(:disabled), .button--info.button--outlined.button--active:not(:disabled) {
            color: #f0f2f2;
            background-color: #163449;
            border-color: #163449; }
      .button--gray {
        background-color: #6D7A7D;
        color: #f0f2f2;
        border-color: #6D7A7D; }
        .button--gray:hover:not(:disabled), .button--gray.button--hovered:not(:disabled) {
          color: #f0f2f2;
          background-color: #8a9597;
          border-color: #8a9597; }
        .button--gray:focus:not(:disabled):not(.button--clear), .button--gray.button--focused:not(:disabled) {
          color: #f0f2f2;
          background-color: #8a9597;
          border-color: #8a9597;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(109, 122, 125, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(109, 122, 125, 0.3); }
        .button--gray:active:not(:disabled):not(.button--clear), .button--gray.button--active:not(:disabled) {
          color: #f0f2f2;
          background-color: #576264;
          border-color: #576264; }
        .button--gray.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #626e71; }
        .button--gray.button--raised:hover:not(:disabled), .button--gray.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #6D7A7D; }
        .button--gray.button--raised:focus:not(:disabled), .button--gray.button--raised.button--focus:not(:disabled) {
          border-color: #7c878a;
          border-bottom-width: 4px;
          border-bottom-color: #626e71;
          background-color: #7c878a;
          margin-top: 0px;
          outline: none; }
        .button--gray.button--raised:active:not(:disabled), .button--gray.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #576264;
          background-color: #576264;
          margin-top: 3px;
          outline: none; }
        .button--gray.button--outlined {
          color: #6D7A7D;
          background-color: transparent; }
          .button--gray.button--outlined:hover:not(:disabled), .button--gray.button--outlined.button--hovered:not(:disabled) {
            color: #f0f2f2;
            background-color: #7c878a;
            border-color: #7c878a; }
          .button--gray.button--outlined:focus:not(:disabled), .button--gray.button--outlined.button--focused:not(:disabled) {
            color: #f0f2f2;
            background-color: #7c878a;
            border-color: #7c878a;
            outline: none; }
          .button--gray.button--outlined:active:not(:disabled), .button--gray.button--outlined.button--active:not(:disabled) {
            color: #f0f2f2;
            background-color: #576264;
            border-color: #576264; }
      .button--light {
        background-color: #e2e4e5;
        color: #2c3132;
        border-color: #e2e4e5; }
        .button--light:hover:not(:disabled), .button--light.button--hovered:not(:disabled) {
          color: #2c3132;
          background-color: #e8e9ea;
          border-color: #e8e9ea; }
        .button--light:focus:not(:disabled):not(.button--clear), .button--light.button--focused:not(:disabled) {
          color: #2c3132;
          background-color: #e8e9ea;
          border-color: #e8e9ea;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(226, 228, 229, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(226, 228, 229, 0.3); }
        .button--light:active:not(:disabled):not(.button--clear), .button--light.button--active:not(:disabled) {
          color: #2c3132;
          background-color: #b5b6b7;
          border-color: #b5b6b7; }
        .button--light.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #cbcdce; }
        .button--light.button--raised:hover:not(:disabled), .button--light.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #e2e4e5; }
        .button--light.button--raised:focus:not(:disabled), .button--light.button--raised.button--focus:not(:disabled) {
          border-color: #e5e7e8;
          border-bottom-width: 4px;
          border-bottom-color: #cbcdce;
          background-color: #e5e7e8;
          margin-top: 0px;
          outline: none; }
        .button--light.button--raised:active:not(:disabled), .button--light.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #b5b6b7;
          background-color: #b5b6b7;
          margin-top: 3px;
          outline: none; }
        .button--light.button--outlined {
          color: #e2e4e5;
          background-color: transparent; }
          .button--light.button--outlined:hover:not(:disabled), .button--light.button--outlined.button--hovered:not(:disabled) {
            color: #2c3132;
            background-color: #e5e7e8;
            border-color: #e5e7e8; }
          .button--light.button--outlined:focus:not(:disabled), .button--light.button--outlined.button--focused:not(:disabled) {
            color: #2c3132;
            background-color: #e5e7e8;
            border-color: #e5e7e8;
            outline: none; }
          .button--light.button--outlined:active:not(:disabled), .button--light.button--outlined.button--active:not(:disabled) {
            color: #2c3132;
            background-color: #b5b6b7;
            border-color: #b5b6b7; }
      .button--lighter {
        background-color: #f0f2f2;
        color: #2c3132;
        border-color: #f0f2f2; }
        .button--lighter:hover:not(:disabled), .button--lighter.button--hovered:not(:disabled) {
          color: #2c3132;
          background-color: #f3f5f5;
          border-color: #f3f5f5; }
        .button--lighter:focus:not(:disabled):not(.button--clear), .button--lighter.button--focused:not(:disabled) {
          color: #2c3132;
          background-color: #f3f5f5;
          border-color: #f3f5f5;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(240, 242, 242, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(240, 242, 242, 0.3); }
        .button--lighter:active:not(:disabled):not(.button--clear), .button--lighter.button--active:not(:disabled) {
          color: #2c3132;
          background-color: #c0c2c2;
          border-color: #c0c2c2; }
        .button--lighter.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #d8dada; }
        .button--lighter.button--raised:hover:not(:disabled), .button--lighter.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #f0f2f2; }
        .button--lighter.button--raised:focus:not(:disabled), .button--lighter.button--raised.button--focus:not(:disabled) {
          border-color: #f2f3f3;
          border-bottom-width: 4px;
          border-bottom-color: #d8dada;
          background-color: #f2f3f3;
          margin-top: 0px;
          outline: none; }
        .button--lighter.button--raised:active:not(:disabled), .button--lighter.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #c0c2c2;
          background-color: #c0c2c2;
          margin-top: 3px;
          outline: none; }
        .button--lighter.button--outlined {
          color: #f0f2f2;
          background-color: transparent; }
          .button--lighter.button--outlined:hover:not(:disabled), .button--lighter.button--outlined.button--hovered:not(:disabled) {
            color: #2c3132;
            background-color: #f2f3f3;
            border-color: #f2f3f3; }
          .button--lighter.button--outlined:focus:not(:disabled), .button--lighter.button--outlined.button--focused:not(:disabled) {
            color: #2c3132;
            background-color: #f2f3f3;
            border-color: #f2f3f3;
            outline: none; }
          .button--lighter.button--outlined:active:not(:disabled), .button--lighter.button--outlined.button--active:not(:disabled) {
            color: #2c3132;
            background-color: #c0c2c2;
            border-color: #c0c2c2; }
      .button--dark {
        background-color: #2c3132;
        color: #f0f2f2;
        border-color: #2c3132; }
        .button--dark:hover:not(:disabled), .button--dark.button--hovered:not(:disabled) {
          color: #f0f2f2;
          background-color: #565a5b;
          border-color: #565a5b; }
        .button--dark:focus:not(:disabled):not(.button--clear), .button--dark.button--focused:not(:disabled) {
          color: #f0f2f2;
          background-color: #565a5b;
          border-color: #565a5b;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(44, 49, 50, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(44, 49, 50, 0.3); }
        .button--dark:active:not(:disabled):not(.button--clear), .button--dark.button--active:not(:disabled) {
          color: #f0f2f2;
          background-color: #232728;
          border-color: #232728; }
        .button--dark.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #282c2d; }
        .button--dark.button--raised:hover:not(:disabled), .button--dark.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #2c3132; }
        .button--dark.button--raised:focus:not(:disabled), .button--dark.button--raised.button--focus:not(:disabled) {
          border-color: #414647;
          border-bottom-width: 4px;
          border-bottom-color: #282c2d;
          background-color: #414647;
          margin-top: 0px;
          outline: none; }
        .button--dark.button--raised:active:not(:disabled), .button--dark.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #232728;
          background-color: #232728;
          margin-top: 3px;
          outline: none; }
        .button--dark.button--outlined {
          color: #2c3132;
          background-color: transparent; }
          .button--dark.button--outlined:hover:not(:disabled), .button--dark.button--outlined.button--hovered:not(:disabled) {
            color: #f0f2f2;
            background-color: #414647;
            border-color: #414647; }
          .button--dark.button--outlined:focus:not(:disabled), .button--dark.button--outlined.button--focused:not(:disabled) {
            color: #f0f2f2;
            background-color: #414647;
            border-color: #414647;
            outline: none; }
          .button--dark.button--outlined:active:not(:disabled), .button--dark.button--outlined.button--active:not(:disabled) {
            color: #f0f2f2;
            background-color: #232728;
            border-color: #232728; }
      .button--darker {
        background-color: #161819;
        color: #f0f2f2;
        border-color: #161819; }
        .button--darker:hover:not(:disabled), .button--darker.button--hovered:not(:disabled) {
          color: #f0f2f2;
          background-color: #454647;
          border-color: #454647; }
        .button--darker:focus:not(:disabled):not(.button--clear), .button--darker.button--focused:not(:disabled) {
          color: #f0f2f2;
          background-color: #454647;
          border-color: #454647;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(22, 24, 25, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(22, 24, 25, 0.3); }
        .button--darker:active:not(:disabled):not(.button--clear), .button--darker.button--active:not(:disabled) {
          color: #f0f2f2;
          background-color: #121314;
          border-color: #121314; }
        .button--darker.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #141617; }
        .button--darker.button--raised:hover:not(:disabled), .button--darker.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #161819; }
        .button--darker.button--raised:focus:not(:disabled), .button--darker.button--raised.button--focus:not(:disabled) {
          border-color: #2d2f30;
          border-bottom-width: 4px;
          border-bottom-color: #141617;
          background-color: #2d2f30;
          margin-top: 0px;
          outline: none; }
        .button--darker.button--raised:active:not(:disabled), .button--darker.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #121314;
          background-color: #121314;
          margin-top: 3px;
          outline: none; }
        .button--darker.button--outlined {
          color: #161819;
          background-color: transparent; }
          .button--darker.button--outlined:hover:not(:disabled), .button--darker.button--outlined.button--hovered:not(:disabled) {
            color: #f0f2f2;
            background-color: #2d2f30;
            border-color: #2d2f30; }
          .button--darker.button--outlined:focus:not(:disabled), .button--darker.button--outlined.button--focused:not(:disabled) {
            color: #f0f2f2;
            background-color: #2d2f30;
            border-color: #2d2f30;
            outline: none; }
          .button--darker.button--outlined:active:not(:disabled), .button--darker.button--outlined.button--active:not(:disabled) {
            color: #f0f2f2;
            background-color: #121314;
            border-color: #121314; }
      .button--tertiary {
        background-color: #002b45;
        color: #f0f2f2;
        border-color: #002b45; }
        .button--tertiary:hover:not(:disabled), .button--tertiary.button--hovered:not(:disabled) {
          color: #f0f2f2;
          background-color: #33556a;
          border-color: #33556a; }
        .button--tertiary:focus:not(:disabled):not(.button--clear), .button--tertiary.button--focused:not(:disabled) {
          color: #f0f2f2;
          background-color: #33556a;
          border-color: #33556a;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(0, 43, 69, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(0, 43, 69, 0.3); }
        .button--tertiary:active:not(:disabled):not(.button--clear), .button--tertiary.button--active:not(:disabled) {
          color: #f0f2f2;
          background-color: #002237;
          border-color: #002237; }
        .button--tertiary.button--raised:not(:disabled) {
          border-bottom-width: 4px;
          border-bottom-color: #00273e; }
        .button--tertiary.button--raised:hover:not(:disabled), .button--tertiary.button--raised.button--hovered:not(:disabled) {
          border-bottom-color: #002b45; }
        .button--tertiary.button--raised:focus:not(:disabled), .button--tertiary.button--raised.button--focus:not(:disabled) {
          border-color: #1a4058;
          border-bottom-width: 4px;
          border-bottom-color: #00273e;
          background-color: #1a4058;
          margin-top: 0px;
          outline: none; }
        .button--tertiary.button--raised:active:not(:disabled), .button--tertiary.button--raised.button--active:not(:disabled) {
          border-bottom-width: 1px;
          border-bottom-color: #002237;
          background-color: #002237;
          margin-top: 3px;
          outline: none; }
        .button--tertiary.button--outlined {
          color: #002b45;
          background-color: transparent; }
          .button--tertiary.button--outlined:hover:not(:disabled), .button--tertiary.button--outlined.button--hovered:not(:disabled) {
            color: #f0f2f2;
            background-color: #1a4058;
            border-color: #1a4058; }
          .button--tertiary.button--outlined:focus:not(:disabled), .button--tertiary.button--outlined.button--focused:not(:disabled) {
            color: #f0f2f2;
            background-color: #1a4058;
            border-color: #1a4058;
            outline: none; }
          .button--tertiary.button--outlined:active:not(:disabled), .button--tertiary.button--outlined.button--active:not(:disabled) {
            color: #f0f2f2;
            background-color: #002237;
            border-color: #002237; }
      .button--x-small {
        font-size: 0.64815rem;
        padding: 0.25em 0.5em; }
      .button--small {
        font-size: 0.76087rem;
        padding: 0.375em 0.75em; }
      .button--base {
        font-size: 0.875rem;
        padding: 0.5em 1em; }
      .button--large {
        font-size: 1.09375rem;
        padding: 0.625em 1.25em; }
      .button--x-large {
        font-size: 1.3125rem;
        padding: 0.75em 1.5em; }
      .button--clear {
        border: none;
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        color: #007dbc; }
        .button--clear:hover:not(:disabled) {
          color: #006496;
          text-decoration: underline; }
      .button--pill {
        border-radius: 50px; }
      .button--full-width {
        width: 100%; }

    .input,
    .textarea {
      width: 100%; }

    .input,
    .select > select,
    .textarea {
      padding: 0.8rem 1rem;
      position: relative;
      -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
      transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
      font-size: 0.875rem;
      background-color: #FFFFFF;
      color: #2c3132;
      border-style: solid;
      border-width: 1px;
      border-color: #e2e4e5;
      border-radius: 4px;
      outline: none;
      white-space: normal; }
      .input:focus,
      .select > select:focus,
      .textarea:focus {
        border-color: #007dbc;
        -webkit-box-shadow: 0 0 0.3em 0.2em rgba(38, 145, 198, 0.3);
                box-shadow: 0 0 0.3em 0.2em rgba(38, 145, 198, 0.3); }
      .input:disabled,
      .select > select:disabled,
      .textarea:disabled {
        background-color: #f0f2f2;
        cursor: not-allowed; }
      .input:hover:not(:disabled),
      .select > select:hover:not(:disabled),
      .textarea:hover:not(:disabled) {
        border-color: #3397c9; }
      .input--primary,
      .select > select--primary,
      .textarea--primary {
        border-color: #3397c9; }
        .input--primary:not(:disabled):hover,
        .select > select--primary:not(:disabled):hover,
        .textarea--primary:not(:disabled):hover {
          border-color: #1a8ac3; }
        .input--primary:focus,
        .select > select--primary:focus,
        .textarea--primary:focus {
          border-color: #007dbc;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(38, 145, 198, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(38, 145, 198, 0.3); }
      .input--secondary,
      .select > select--secondary,
      .textarea--secondary {
        border-color: #9acb67; }
        .input--secondary:not(:disabled):hover,
        .select > select--secondary:not(:disabled):hover,
        .textarea--secondary:not(:disabled):hover {
          border-color: #8ec554; }
        .input--secondary:focus,
        .select > select--secondary:focus,
        .textarea--secondary:focus {
          border-color: #81be41;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(148, 200, 94, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(148, 200, 94, 0.3); }
      .input--success,
      .select > select--success,
      .textarea--success {
        border-color: #6dba33; }
        .input--success:not(:disabled):hover,
        .select > select--success:not(:disabled):hover,
        .textarea--success:not(:disabled):hover {
          border-color: #5ab21a; }
        .input--success:focus,
        .select > select--success:focus,
        .textarea--success:focus {
          border-color: #48a900;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(99, 182, 38, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(99, 182, 38, 0.3); }
      .input--warning,
      .select > select--warning,
      .textarea--warning {
        border-color: #efd133; }
        .input--warning:not(:disabled):hover,
        .select > select--warning:not(:disabled):hover,
        .textarea--warning:not(:disabled):hover {
          border-color: #edcb1a; }
        .input--warning:focus,
        .select > select--warning:focus,
        .textarea--warning:focus {
          border-color: #ebc500;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(238, 206, 38, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(238, 206, 38, 0.3); }
      .input--danger,
      .select > select--danger,
      .textarea--danger {
        border-color: #ed7a44; }
        .input--danger:not(:disabled):hover,
        .select > select--danger:not(:disabled):hover,
        .textarea--danger:not(:disabled):hover {
          border-color: #ea6a2c; }
        .input--danger:focus,
        .select > select--danger:focus,
        .textarea--danger:focus {
          border-color: #e85915;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(235, 114, 56, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(235, 114, 56, 0.3); }
      .input--info,
      .select > select--info,
      .textarea--info {
        border-color: #49677c; }
        .input--info:not(:disabled):hover,
        .select > select--info:not(:disabled):hover,
        .textarea--info:not(:disabled):hover {
          border-color: #33546b; }
        .input--info:focus,
        .select > select--info:focus,
        .textarea--info:focus {
          border-color: #1C415B;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(62, 94, 116, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(62, 94, 116, 0.3); }
      .input--gray,
      .select > select--gray,
      .textarea--gray {
        border-color: #8a9597; }
        .input--gray:not(:disabled):hover,
        .select > select--gray:not(:disabled):hover,
        .textarea--gray:not(:disabled):hover {
          border-color: #7c878a; }
        .input--gray:focus,
        .select > select--gray:focus,
        .textarea--gray:focus {
          border-color: #6D7A7D;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(131, 142, 145, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(131, 142, 145, 0.3); }
      .input--light,
      .select > select--light,
      .textarea--light {
        border-color: #e8e9ea; }
        .input--light:not(:disabled):hover,
        .select > select--light:not(:disabled):hover,
        .textarea--light:not(:disabled):hover {
          border-color: #e5e7e8; }
        .input--light:focus,
        .select > select--light:focus,
        .textarea--light:focus {
          border-color: #e2e4e5;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(230, 232, 233, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(230, 232, 233, 0.3); }
      .input--lighter,
      .select > select--lighter,
      .textarea--lighter {
        border-color: #f3f5f5; }
        .input--lighter:not(:disabled):hover,
        .select > select--lighter:not(:disabled):hover,
        .textarea--lighter:not(:disabled):hover {
          border-color: #f2f3f3; }
        .input--lighter:focus,
        .select > select--lighter:focus,
        .textarea--lighter:focus {
          border-color: #f0f2f2;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(242, 244, 244, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(242, 244, 244, 0.3); }
      .input--dark,
      .select > select--dark,
      .textarea--dark {
        border-color: #565a5b; }
        .input--dark:not(:disabled):hover,
        .select > select--dark:not(:disabled):hover,
        .textarea--dark:not(:disabled):hover {
          border-color: #414647; }
        .input--dark:focus,
        .select > select--dark:focus,
        .textarea--dark:focus {
          border-color: #2c3132;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(76, 80, 81, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(76, 80, 81, 0.3); }
      .input--darker,
      .select > select--darker,
      .textarea--darker {
        border-color: #454647; }
        .input--darker:not(:disabled):hover,
        .select > select--darker:not(:disabled):hover,
        .textarea--darker:not(:disabled):hover {
          border-color: #2d2f30; }
        .input--darker:focus,
        .select > select--darker:focus,
        .textarea--darker:focus {
          border-color: #161819;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(57, 59, 60, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(57, 59, 60, 0.3); }
      .input--tertiary,
      .select > select--tertiary,
      .textarea--tertiary {
        border-color: #33556a; }
        .input--tertiary:not(:disabled):hover,
        .select > select--tertiary:not(:disabled):hover,
        .textarea--tertiary:not(:disabled):hover {
          border-color: #1a4058; }
        .input--tertiary:focus,
        .select > select--tertiary:focus,
        .textarea--tertiary:focus {
          border-color: #002b45;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(38, 75, 97, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(38, 75, 97, 0.3); }
      .input--xx-small,
      .select > select--xx-small,
      .textarea--xx-small {
        font-size: 0.5rem;
        padding: 0.4rem; }
      .input--x-small,
      .select > select--x-small,
      .textarea--x-small {
        font-size: 0.64815rem;
        padding: 0.57143rem; }
      .input--small,
      .select > select--small,
      .textarea--small {
        font-size: 0.76087rem;
        padding: 0.8rem; }
      .input--base,
      .select > select--base,
      .textarea--base {
        font-size: 0.875rem;
        padding: 1rem; }
      .input--large,
      .select > select--large,
      .textarea--large {
        font-size: 1.09375rem;
        padding: 1.5rem; }
      .input--x-large,
      .select > select--x-large,
      .textarea--x-large {
        font-size: 1.3125rem;
        padding: 2rem; }
      .input--xx-large,
      .select > select--xx-large,
      .textarea--xx-large {
        font-size: 1.75rem;
        padding: 3rem; }
      .input--pill,
      .select > select--pill,
      .textarea--pill {
        border-radius: 50px; }

    .select {
      position: relative; }
      .select--expanded {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1; }
        .select--expanded > select {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1; }
      .select > select {
        -webkit-appearance: none;
        -moz-appearance: none;
        padding-right: 3em;
        cursor: pointer; }
      .select:after {
        content: "\\f078";
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        position: absolute;
        pointer-events: none;
        right: 1rem;
        top: 50%;
        -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
        line-height: 0;
        color: #6D7A7D;
        z-index: 5; }
      .select:focus-within:after {
        -webkit-transform: rotate(180deg) translateY(-50%);
                transform: rotate(180deg) translateY(-50%);
        color: #007dbc; }

    .input-set {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
          -ms-flex-direction: row;
              flex-direction: row;
      -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
      transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
      border-style: solid;
      border-width: 1px;
      border-color: #e2e4e5;
      border-radius: 4px;
      background-color: #FFFFFF;
      overflow: hidden;
      width: 100%; }
      .input-set:hover {
        border-color: #3397c9; }
      .input-set:focus-within {
        -webkit-box-shadow: 0 0 0.3em 0.2em rgba(38, 145, 198, 0.3);
                box-shadow: 0 0 0.3em 0.2em rgba(38, 145, 198, 0.3);
        border-color: #007dbc; }
        .input-set:focus-within .input-set__icon > .icon {
          color: #007dbc; }
        .input-set:focus-within .input-set__extra {
          background-color: #007dbc;
          color: #f0f2f2; }
      .input-set--primary {
        border-color: #007dbc; }
        .input-set--primary .input-set__icon > .icon {
          color: #007dbc; }
        .input-set--primary .input-set__extra {
          background-color: #007dbc;
          color: #f0f2f2; }
        .input-set--primary:hover {
          border-color: #007dbc; }
        .input-set--primary:focus-within {
          border-color: #007dbc;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(38, 145, 198, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(38, 145, 198, 0.3); }
          .input-set--primary:focus-within .input-set__icon > .icon {
            color: #007dbc; }
          .input-set--primary:focus-within .input-set__extra {
            background-color: #007dbc;
            color: #f0f2f2; }
      .input-set--secondary {
        border-color: #81be41; }
        .input-set--secondary .input-set__icon > .icon {
          color: #81be41; }
        .input-set--secondary .input-set__extra {
          background-color: #81be41;
          color: #f0f2f2; }
        .input-set--secondary:hover {
          border-color: #81be41; }
        .input-set--secondary:focus-within {
          border-color: #81be41;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(148, 200, 94, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(148, 200, 94, 0.3); }
          .input-set--secondary:focus-within .input-set__icon > .icon {
            color: #81be41; }
          .input-set--secondary:focus-within .input-set__extra {
            background-color: #81be41;
            color: #f0f2f2; }
      .input-set--success {
        border-color: #48a900; }
        .input-set--success .input-set__icon > .icon {
          color: #48a900; }
        .input-set--success .input-set__extra {
          background-color: #48a900;
          color: #f0f2f2; }
        .input-set--success:hover {
          border-color: #48a900; }
        .input-set--success:focus-within {
          border-color: #48a900;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(99, 182, 38, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(99, 182, 38, 0.3); }
          .input-set--success:focus-within .input-set__icon > .icon {
            color: #48a900; }
          .input-set--success:focus-within .input-set__extra {
            background-color: #48a900;
            color: #f0f2f2; }
      .input-set--warning {
        border-color: #ebc500; }
        .input-set--warning .input-set__icon > .icon {
          color: #ebc500; }
        .input-set--warning .input-set__extra {
          background-color: #ebc500;
          color: #f0f2f2; }
        .input-set--warning:hover {
          border-color: #ebc500; }
        .input-set--warning:focus-within {
          border-color: #ebc500;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(238, 206, 38, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(238, 206, 38, 0.3); }
          .input-set--warning:focus-within .input-set__icon > .icon {
            color: #ebc500; }
          .input-set--warning:focus-within .input-set__extra {
            background-color: #ebc500;
            color: #f0f2f2; }
      .input-set--danger {
        border-color: #e85915; }
        .input-set--danger .input-set__icon > .icon {
          color: #e85915; }
        .input-set--danger .input-set__extra {
          background-color: #e85915;
          color: #f0f2f2; }
        .input-set--danger:hover {
          border-color: #e85915; }
        .input-set--danger:focus-within {
          border-color: #e85915;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(235, 114, 56, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(235, 114, 56, 0.3); }
          .input-set--danger:focus-within .input-set__icon > .icon {
            color: #e85915; }
          .input-set--danger:focus-within .input-set__extra {
            background-color: #e85915;
            color: #f0f2f2; }
      .input-set--info {
        border-color: #1C415B; }
        .input-set--info .input-set__icon > .icon {
          color: #1C415B; }
        .input-set--info .input-set__extra {
          background-color: #1C415B;
          color: #f0f2f2; }
        .input-set--info:hover {
          border-color: #1C415B; }
        .input-set--info:focus-within {
          border-color: #1C415B;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(62, 94, 116, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(62, 94, 116, 0.3); }
          .input-set--info:focus-within .input-set__icon > .icon {
            color: #1C415B; }
          .input-set--info:focus-within .input-set__extra {
            background-color: #1C415B;
            color: #f0f2f2; }
      .input-set--gray {
        border-color: #6D7A7D; }
        .input-set--gray .input-set__icon > .icon {
          color: #6D7A7D; }
        .input-set--gray .input-set__extra {
          background-color: #6D7A7D;
          color: #f0f2f2; }
        .input-set--gray:hover {
          border-color: #6D7A7D; }
        .input-set--gray:focus-within {
          border-color: #6D7A7D;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(131, 142, 145, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(131, 142, 145, 0.3); }
          .input-set--gray:focus-within .input-set__icon > .icon {
            color: #6D7A7D; }
          .input-set--gray:focus-within .input-set__extra {
            background-color: #6D7A7D;
            color: #f0f2f2; }
      .input-set--light {
        border-color: #e2e4e5; }
        .input-set--light .input-set__icon > .icon {
          color: #e2e4e5; }
        .input-set--light .input-set__extra {
          background-color: #e2e4e5;
          color: #2c3132; }
        .input-set--light:hover {
          border-color: #e2e4e5; }
        .input-set--light:focus-within {
          border-color: #e2e4e5;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(230, 232, 233, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(230, 232, 233, 0.3); }
          .input-set--light:focus-within .input-set__icon > .icon {
            color: #e2e4e5; }
          .input-set--light:focus-within .input-set__extra {
            background-color: #e2e4e5;
            color: #2c3132; }
      .input-set--lighter {
        border-color: #f0f2f2; }
        .input-set--lighter .input-set__icon > .icon {
          color: #f0f2f2; }
        .input-set--lighter .input-set__extra {
          background-color: #f0f2f2;
          color: #2c3132; }
        .input-set--lighter:hover {
          border-color: #f0f2f2; }
        .input-set--lighter:focus-within {
          border-color: #f0f2f2;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(242, 244, 244, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(242, 244, 244, 0.3); }
          .input-set--lighter:focus-within .input-set__icon > .icon {
            color: #f0f2f2; }
          .input-set--lighter:focus-within .input-set__extra {
            background-color: #f0f2f2;
            color: #2c3132; }
      .input-set--dark {
        border-color: #2c3132; }
        .input-set--dark .input-set__icon > .icon {
          color: #2c3132; }
        .input-set--dark .input-set__extra {
          background-color: #2c3132;
          color: #f0f2f2; }
        .input-set--dark:hover {
          border-color: #2c3132; }
        .input-set--dark:focus-within {
          border-color: #2c3132;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(76, 80, 81, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(76, 80, 81, 0.3); }
          .input-set--dark:focus-within .input-set__icon > .icon {
            color: #2c3132; }
          .input-set--dark:focus-within .input-set__extra {
            background-color: #2c3132;
            color: #f0f2f2; }
      .input-set--darker {
        border-color: #161819; }
        .input-set--darker .input-set__icon > .icon {
          color: #161819; }
        .input-set--darker .input-set__extra {
          background-color: #161819;
          color: #f0f2f2; }
        .input-set--darker:hover {
          border-color: #161819; }
        .input-set--darker:focus-within {
          border-color: #161819;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(57, 59, 60, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(57, 59, 60, 0.3); }
          .input-set--darker:focus-within .input-set__icon > .icon {
            color: #161819; }
          .input-set--darker:focus-within .input-set__extra {
            background-color: #161819;
            color: #f0f2f2; }
      .input-set--tertiary {
        border-color: #002b45; }
        .input-set--tertiary .input-set__icon > .icon {
          color: #002b45; }
        .input-set--tertiary .input-set__extra {
          background-color: #002b45;
          color: #f0f2f2; }
        .input-set--tertiary:hover {
          border-color: #002b45; }
        .input-set--tertiary:focus-within {
          border-color: #002b45;
          -webkit-box-shadow: 0 0 0.3em 0.2em rgba(38, 75, 97, 0.3);
                  box-shadow: 0 0 0.3em 0.2em rgba(38, 75, 97, 0.3); }
          .input-set--tertiary:focus-within .input-set__icon > .icon {
            color: #002b45; }
          .input-set--tertiary:focus-within .input-set__extra {
            background-color: #002b45;
            color: #f0f2f2; }
      .input-set__extra {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        padding-left: 1rem;
        padding-right: 1rem;
        background-color: #e2e4e5; }
      .input-set__icon {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83); }
        .input-set__icon > .icon {
          color: #6D7A7D; }
        .input-set__icon:first-child {
          padding-left: 1rem; }
        .input-set__icon:last-child {
          padding-right: 1rem; }
      .input-set > .input,
      .input-set > .select {
        border: none;
        -webkit-box-shadow: none;
                box-shadow: none; }

    .card, .tnk-card {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
          -ms-flex-direction: column;
              flex-direction: column;
      position: relative;
      background-color: #FFFFFF;
      border-radius: 4px;
      border: solid 1px #e2e4e5;
      word-wrap: break-word;
      overflow: hidden; }
      .card__header, .tnk-card .tnk-card__header, .card__body, .tnk-card .tnk-card__body, .card__footer, .tnk-card .tnk-card__footer {
        padding: 1rem; }
      .card__header, .tnk-card .tnk-card__header {
        border-bottom: solid 1px #e2e4e5; }
        .card__header--primary {
          background-color: #007dbc;
          border: solid 1px #007dbc;
          color: #f0f2f2; }
        .card__header--secondary {
          background-color: #81be41;
          border: solid 1px #81be41;
          color: #f0f2f2; }
        .card__header--success {
          background-color: #48a900;
          border: solid 1px #48a900;
          color: #f0f2f2; }
        .card__header--warning {
          background-color: #ebc500;
          border: solid 1px #ebc500;
          color: #f0f2f2; }
        .card__header--danger {
          background-color: #e85915;
          border: solid 1px #e85915;
          color: #f0f2f2; }
        .card__header--info {
          background-color: #1C415B;
          border: solid 1px #1C415B;
          color: #f0f2f2; }
        .card__header--gray {
          background-color: #6D7A7D;
          border: solid 1px #6D7A7D;
          color: #f0f2f2; }
        .card__header--light {
          background-color: #e2e4e5;
          border: solid 1px #e2e4e5;
          color: #2c3132; }
        .card__header--lighter {
          background-color: #f0f2f2;
          border: solid 1px #f0f2f2;
          color: #2c3132; }
        .card__header--dark {
          background-color: #2c3132;
          border: solid 1px #2c3132;
          color: #f0f2f2; }
        .card__header--darker {
          background-color: #161819;
          border: solid 1px #161819;
          color: #f0f2f2; }
        .card__header--tertiary {
          background-color: #002b45;
          border: solid 1px #002b45;
          color: #f0f2f2; }
      .card .card__image, .tnk-card .card__image {
        position: relative;
        height: 200px;
        min-height: 200px;
        overflow: hidden; }
        .card .card__image > img, .tnk-card .card__image > img {
          height: 100%;
          width: 100%;
          -o-object-fit: cover;
             object-fit: cover;
          -o-object-position: center;
             object-position: center; }
      .card--primary {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #007dbc;
        color: #f0f2f2;
        border: solid 1px #0071a9;
        overflow: hidden; }
        .card--primary.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--primary.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #007dbc;
            color: #f0f2f2;
            opacity: 0.7;
            z-index: 10; }
          .card--primary.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--primary.card--has-overlay .card__header, .card--primary.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--primary.card--has-overlay .tnk-card__header,
          .card--primary.card--has-overlay .card__body,
          .card--primary.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--primary.card--has-overlay .tnk-card__body,
          .card--primary.card--has-overlay .card__footer,
          .card--primary.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--primary.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--secondary {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #81be41;
        color: #f0f2f2;
        border: solid 1px #74ab3b;
        overflow: hidden; }
        .card--secondary.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--secondary.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #81be41;
            color: #f0f2f2;
            opacity: 0.7;
            z-index: 10; }
          .card--secondary.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--secondary.card--has-overlay .card__header, .card--secondary.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--secondary.card--has-overlay .tnk-card__header,
          .card--secondary.card--has-overlay .card__body,
          .card--secondary.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--secondary.card--has-overlay .tnk-card__body,
          .card--secondary.card--has-overlay .card__footer,
          .card--secondary.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--secondary.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--success {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #48a900;
        color: #f0f2f2;
        border: solid 1px #419800;
        overflow: hidden; }
        .card--success.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--success.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #48a900;
            color: #f0f2f2;
            opacity: 0.7;
            z-index: 10; }
          .card--success.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--success.card--has-overlay .card__header, .card--success.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--success.card--has-overlay .tnk-card__header,
          .card--success.card--has-overlay .card__body,
          .card--success.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--success.card--has-overlay .tnk-card__body,
          .card--success.card--has-overlay .card__footer,
          .card--success.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--success.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--warning {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #ebc500;
        color: #f0f2f2;
        border: solid 1px #d4b100;
        overflow: hidden; }
        .card--warning.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--warning.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #ebc500;
            color: #f0f2f2;
            opacity: 0.7;
            z-index: 10; }
          .card--warning.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--warning.card--has-overlay .card__header, .card--warning.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--warning.card--has-overlay .tnk-card__header,
          .card--warning.card--has-overlay .card__body,
          .card--warning.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--warning.card--has-overlay .tnk-card__body,
          .card--warning.card--has-overlay .card__footer,
          .card--warning.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--warning.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--danger {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #e85915;
        color: #f0f2f2;
        border: solid 1px #d15013;
        overflow: hidden; }
        .card--danger.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--danger.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #e85915;
            color: #f0f2f2;
            opacity: 0.7;
            z-index: 10; }
          .card--danger.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--danger.card--has-overlay .card__header, .card--danger.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--danger.card--has-overlay .tnk-card__header,
          .card--danger.card--has-overlay .card__body,
          .card--danger.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--danger.card--has-overlay .tnk-card__body,
          .card--danger.card--has-overlay .card__footer,
          .card--danger.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--danger.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--info {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #1C415B;
        color: #f0f2f2;
        border: solid 1px #193b52;
        overflow: hidden; }
        .card--info.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--info.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #1C415B;
            color: #f0f2f2;
            opacity: 0.7;
            z-index: 10; }
          .card--info.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--info.card--has-overlay .card__header, .card--info.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--info.card--has-overlay .tnk-card__header,
          .card--info.card--has-overlay .card__body,
          .card--info.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--info.card--has-overlay .tnk-card__body,
          .card--info.card--has-overlay .card__footer,
          .card--info.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--info.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--gray {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #6D7A7D;
        color: #f0f2f2;
        border: solid 1px #626e71;
        overflow: hidden; }
        .card--gray.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--gray.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #6D7A7D;
            color: #f0f2f2;
            opacity: 0.7;
            z-index: 10; }
          .card--gray.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--gray.card--has-overlay .card__header, .card--gray.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--gray.card--has-overlay .tnk-card__header,
          .card--gray.card--has-overlay .card__body,
          .card--gray.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--gray.card--has-overlay .tnk-card__body,
          .card--gray.card--has-overlay .card__footer,
          .card--gray.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--gray.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--light {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #e2e4e5;
        color: #2c3132;
        border: solid 1px #cbcdce;
        overflow: hidden; }
        .card--light.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--light.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #e2e4e5;
            color: #2c3132;
            opacity: 0.7;
            z-index: 10; }
          .card--light.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--light.card--has-overlay .card__header, .card--light.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--light.card--has-overlay .tnk-card__header,
          .card--light.card--has-overlay .card__body,
          .card--light.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--light.card--has-overlay .tnk-card__body,
          .card--light.card--has-overlay .card__footer,
          .card--light.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--light.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--lighter {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #f0f2f2;
        color: #2c3132;
        border: solid 1px #d8dada;
        overflow: hidden; }
        .card--lighter.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--lighter.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #f0f2f2;
            color: #2c3132;
            opacity: 0.7;
            z-index: 10; }
          .card--lighter.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--lighter.card--has-overlay .card__header, .card--lighter.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--lighter.card--has-overlay .tnk-card__header,
          .card--lighter.card--has-overlay .card__body,
          .card--lighter.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--lighter.card--has-overlay .tnk-card__body,
          .card--lighter.card--has-overlay .card__footer,
          .card--lighter.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--lighter.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--dark {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #2c3132;
        color: #f0f2f2;
        border: solid 1px #282c2d;
        overflow: hidden; }
        .card--dark.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--dark.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #2c3132;
            color: #f0f2f2;
            opacity: 0.7;
            z-index: 10; }
          .card--dark.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--dark.card--has-overlay .card__header, .card--dark.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--dark.card--has-overlay .tnk-card__header,
          .card--dark.card--has-overlay .card__body,
          .card--dark.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--dark.card--has-overlay .tnk-card__body,
          .card--dark.card--has-overlay .card__footer,
          .card--dark.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--dark.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--darker {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #161819;
        color: #f0f2f2;
        border: solid 1px #141617;
        overflow: hidden; }
        .card--darker.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--darker.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #161819;
            color: #f0f2f2;
            opacity: 0.7;
            z-index: 10; }
          .card--darker.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--darker.card--has-overlay .card__header, .card--darker.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--darker.card--has-overlay .tnk-card__header,
          .card--darker.card--has-overlay .card__body,
          .card--darker.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--darker.card--has-overlay .tnk-card__body,
          .card--darker.card--has-overlay .card__footer,
          .card--darker.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--darker.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--tertiary {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #002b45;
        color: #f0f2f2;
        border: solid 1px #00273e;
        overflow: hidden; }
        .card--tertiary.card--has-overlay {
          display: -webkit-box;
          display: -moz-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-direction: normal;
          -webkit-box-orient: vertical;
          -moz-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          -moz-justify-content: flex-end;
          justify-content: flex-end;
          min-height: 15em;
          border: 0; }
          .card--tertiary.card--has-overlay:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #002b45;
            color: #f0f2f2;
            opacity: 0.7;
            z-index: 10; }
          .card--tertiary.card--has-overlay .card__image {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 5; }
          .card--tertiary.card--has-overlay .card__header, .card--tertiary.card--has-overlay .tnk-card .tnk-card__header, .tnk-card .card--tertiary.card--has-overlay .tnk-card__header,
          .card--tertiary.card--has-overlay .card__body,
          .card--tertiary.card--has-overlay .tnk-card .tnk-card__body,
          .tnk-card .card--tertiary.card--has-overlay .tnk-card__body,
          .card--tertiary.card--has-overlay .card__footer,
          .card--tertiary.card--has-overlay .tnk-card .tnk-card__footer,
          .tnk-card .card--tertiary.card--has-overlay .tnk-card__footer {
            z-index: 15; }
      .card--transparent {
        border: 0;
        background: transparent; }
        .card--transparent .card__header, .card--transparent .tnk-card .tnk-card__header, .tnk-card .card--transparent .tnk-card__header,
        .card--transparent .card__body,
        .card--transparent .tnk-card .tnk-card__body,
        .tnk-card .card--transparent .tnk-card__body,
        .card--transparent .card__footer,
        .card--transparent .tnk-card .tnk-card__footer,
        .tnk-card .card--transparent .tnk-card__footer {
          padding-left: 0;
          padding-right: 0; }
        .card--transparent .card__image {
          border-radius: 4px; }

    .table {
      border-radius: 4px;
      overflow: hidden; }
      .table > table {
        width: 100%;
        text-align: left; }
      .table__head {
        border-bottom-width: 3px;
        border-bottom-style: solid;
        border-bottom-color: #e2e4e5; }
        .table__head--primary {
          background-color: #007dbc;
          color: #f0f2f2;
          border-bottom-color: #0071a9; }
        .table__head--secondary {
          background-color: #81be41;
          color: #f0f2f2;
          border-bottom-color: #74ab3b; }
        .table__head--success {
          background-color: #48a900;
          color: #f0f2f2;
          border-bottom-color: #419800; }
        .table__head--warning {
          background-color: #ebc500;
          color: #f0f2f2;
          border-bottom-color: #d4b100; }
        .table__head--danger {
          background-color: #e85915;
          color: #f0f2f2;
          border-bottom-color: #d15013; }
        .table__head--info {
          background-color: #1C415B;
          color: #f0f2f2;
          border-bottom-color: #193b52; }
        .table__head--gray {
          background-color: #6D7A7D;
          color: #f0f2f2;
          border-bottom-color: #626e71; }
        .table__head--light {
          background-color: #e2e4e5;
          color: #2c3132;
          border-bottom-color: #cbcdce; }
        .table__head--lighter {
          background-color: #f0f2f2;
          color: #2c3132;
          border-bottom-color: #d8dada; }
        .table__head--dark {
          background-color: #2c3132;
          color: #f0f2f2;
          border-bottom-color: #282c2d; }
        .table__head--darker {
          background-color: #161819;
          color: #f0f2f2;
          border-bottom-color: #141617; }
        .table__head--tertiary {
          background-color: #002b45;
          color: #f0f2f2;
          border-bottom-color: #00273e; }
        .table__head > tr > th {
          padding: 1rem; }
      .table__body > tr {
        background-color: #FFFFFF;
        border-bottom: solid 1px #f0f2f2; }
        .table__body > tr > td {
          padding: 1rem; }
      .table--striped .table__body > tr:nth-child(2n + 2) {
        background-color: #f0f2f2; }

    .fs-xx-small, .font-size-xx-small {
      font-size: 0.5rem !important; }

    .fs-x-small, .font-size-x-small {
      font-size: 0.64815rem !important; }

    .fs-small, .font-size-small {
      font-size: 0.76087rem !important; }

    .fs-base, .font-size-base {
      font-size: 0.875rem !important; }

    .fs-large, .font-size-large {
      font-size: 1.09375rem !important; }

    .fs-x-large, .font-size-x-large {
      font-size: 1.3125rem !important; }

    .fs-xx-large, .font-size-xx-large {
      font-size: 1.75rem !important; }

    .fw-thin, .font-weight-thin {
      font-weight: 100 !important; }

    .fw-extra-light, .font-weight-extra-light {
      font-weight: 200 !important; }

    .fw-ultra-light, .font-weight-ultra-light {
      font-weight: 200 !important; }

    .fw-light, .font-weight-light {
      font-weight: 300 !important; }

    .fw-normal, .font-weight-normal {
      font-weight: 400 !important; }

    .fw-book, .font-weight-book {
      font-weight: 400 !important; }

    .fw-regular, .font-weight-regular {
      font-weight: 400 !important; }

    .fw-medium, .font-weight-medium {
      font-weight: 500 !important; }

    .fw-semi-bold, .font-weight-semi-bold {
      font-weight: 600 !important; }

    .fw-semibold, .font-weight-semibold {
      font-weight: 600 !important; }

    .fw-demi-bold, .font-weight-demi-bold {
      font-weight: 600 !important; }

    .fw-bold, .font-weight-bold {
      font-weight: 700 !important; }

    .fw-extra-bold, .font-weight-extra-bold {
      font-weight: 800 !important; }

    .fw-ultra-bold, .font-weight-ultra-bold {
      font-weight: 900 !important; }

    .fw-heavy, .font-weight-heavy {
      font-weight: 900 !important; }

    .fw-black, .font-weight-black {
      font-weight: 900 !important; }

    .fw-ultra, .font-weight-ultra {
      font-weight: 900 !important; }

    .fw-ultra-black, .font-weight-ultra-black {
      font-weight: 900 !important; }

    .fw-extra-ultra, .font-weight-extra-ultra {
      font-weight: 900 !important; }

    .ta-left, .align-left {
      text-align: left !important; }

    .ta-right, .align-right {
      text-align: right !important; }

    .ta-center, .align-center {
      text-align: center !important; }

    .ta-justify, .align-justify {
      text-align: justify !important; }

    .ta-justify-all, .align-justify-all {
      text-align: justify-all !important; }

    .ta-start, .align-start {
      text-align: start !important; }

    .ta-end, .align-end {
      text-align: end !important; }

    .ta-match-parent, .align-match-parent {
      text-align: match-parent !important; }

    .color-primary {
      color: #007dbc !important; }

    .bg-color-primary {
      background-color: #007dbc !important; }

    .color-secondary {
      color: #81be41 !important; }

    .bg-color-secondary {
      background-color: #81be41 !important; }

    .color-success {
      color: #48a900 !important; }

    .bg-color-success {
      background-color: #48a900 !important; }

    .color-warning {
      color: #ebc500 !important; }

    .bg-color-warning {
      background-color: #ebc500 !important; }

    .color-danger {
      color: #e85915 !important; }

    .bg-color-danger {
      background-color: #e85915 !important; }

    .color-info {
      color: #1C415B !important; }

    .bg-color-info {
      background-color: #1C415B !important; }

    .color-gray {
      color: #6D7A7D !important; }

    .bg-color-gray {
      background-color: #6D7A7D !important; }

    .color-light {
      color: #e2e4e5 !important; }

    .bg-color-light {
      background-color: #e2e4e5 !important; }

    .color-lighter {
      color: #f0f2f2 !important; }

    .bg-color-lighter {
      background-color: #f0f2f2 !important; }

    .color-dark {
      color: #2c3132 !important; }

    .bg-color-dark {
      background-color: #2c3132 !important; }

    .color-darker {
      color: #161819 !important; }

    .bg-color-darker {
      background-color: #161819 !important; }

    .color-tertiary {
      color: #002b45 !important; }

    .bg-color-tertiary {
      background-color: #002b45 !important; }

    .margin, .mg {
      margin: 1rem !important; }

    .padding, .pd {
      padding: 1rem !important; }

    .margin-xx-small, .mg-xx-small {
      margin: 0.4rem !important; }

    .padding-xx-small, .pd-xx-small {
      padding: 0.4rem !important; }

    .margin, .mg {
      margin: 1rem !important; }

    .padding, .pd {
      padding: 1rem !important; }

    .margin-x-small, .mg-x-small {
      margin: 0.57143rem !important; }

    .padding-x-small, .pd-x-small {
      padding: 0.57143rem !important; }

    .margin, .mg {
      margin: 1rem !important; }

    .padding, .pd {
      padding: 1rem !important; }

    .margin-small, .mg-small {
      margin: 0.8rem !important; }

    .padding-small, .pd-small {
      padding: 0.8rem !important; }

    .margin, .mg {
      margin: 1rem !important; }

    .padding, .pd {
      padding: 1rem !important; }

    .margin-base, .mg-base {
      margin: 1rem !important; }

    .padding-base, .pd-base {
      padding: 1rem !important; }

    .margin, .mg {
      margin: 1rem !important; }

    .padding, .pd {
      padding: 1rem !important; }

    .margin-large, .mg-large {
      margin: 1.5rem !important; }

    .padding-large, .pd-large {
      padding: 1.5rem !important; }

    .margin, .mg {
      margin: 1rem !important; }

    .padding, .pd {
      padding: 1rem !important; }

    .margin-x-large, .mg-x-large {
      margin: 2rem !important; }

    .padding-x-large, .pd-x-large {
      padding: 2rem !important; }

    .margin, .mg {
      margin: 1rem !important; }

    .padding, .pd {
      padding: 1rem !important; }

    .margin-xx-large, .mg-xx-large {
      margin: 3rem !important; }

    .padding-xx-large, .pd-xx-large {
      padding: 3rem !important; }

    .pd-top, .padding-top {
      padding-top: 1rem !important; }

    .mg-top, .margin-top {
      margin-top: 1rem !important; }

    .mg-top-xx-small, .margin-top-xx-small {
      margin-top: 0.4rem !important; }

    .pd-top-xx-small, .padding-top-xx-small {
      padding-top: 0.4rem !important; }

    .mg-top-x-small, .margin-top-x-small {
      margin-top: 0.57143rem !important; }

    .pd-top-x-small, .padding-top-x-small {
      padding-top: 0.57143rem !important; }

    .mg-top-small, .margin-top-small {
      margin-top: 0.8rem !important; }

    .pd-top-small, .padding-top-small {
      padding-top: 0.8rem !important; }

    .mg-top-base, .margin-top-base {
      margin-top: 1rem !important; }

    .pd-top-base, .padding-top-base {
      padding-top: 1rem !important; }

    .mg-top-large, .margin-top-large {
      margin-top: 1.5rem !important; }

    .pd-top-large, .padding-top-large {
      padding-top: 1.5rem !important; }

    .mg-top-x-large, .margin-top-x-large {
      margin-top: 2rem !important; }

    .pd-top-x-large, .padding-top-x-large {
      padding-top: 2rem !important; }

    .mg-top-xx-large, .margin-top-xx-large {
      margin-top: 3rem !important; }

    .pd-top-xx-large, .padding-top-xx-large {
      padding-top: 3rem !important; }

    .pd-left, .padding-left {
      padding-left: 1rem !important; }

    .mg-left, .margin-left {
      margin-left: 1rem !important; }

    .mg-left-xx-small, .margin-left-xx-small {
      margin-left: 0.4rem !important; }

    .pd-left-xx-small, .padding-left-xx-small {
      padding-left: 0.4rem !important; }

    .mg-left-x-small, .margin-left-x-small {
      margin-left: 0.57143rem !important; }

    .pd-left-x-small, .padding-left-x-small {
      padding-left: 0.57143rem !important; }

    .mg-left-small, .margin-left-small {
      margin-left: 0.8rem !important; }

    .pd-left-small, .padding-left-small {
      padding-left: 0.8rem !important; }

    .mg-left-base, .margin-left-base {
      margin-left: 1rem !important; }

    .pd-left-base, .padding-left-base {
      padding-left: 1rem !important; }

    .mg-left-large, .margin-left-large {
      margin-left: 1.5rem !important; }

    .pd-left-large, .padding-left-large {
      padding-left: 1.5rem !important; }

    .mg-left-x-large, .margin-left-x-large {
      margin-left: 2rem !important; }

    .pd-left-x-large, .padding-left-x-large {
      padding-left: 2rem !important; }

    .mg-left-xx-large, .margin-left-xx-large {
      margin-left: 3rem !important; }

    .pd-left-xx-large, .padding-left-xx-large {
      padding-left: 3rem !important; }

    .pd-bottom, .padding-bottom {
      padding-bottom: 1rem !important; }

    .mg-bottom, .margin-bottom {
      margin-bottom: 1rem !important; }

    .mg-bottom-xx-small, .margin-bottom-xx-small {
      margin-bottom: 0.4rem !important; }

    .pd-bottom-xx-small, .padding-bottom-xx-small {
      padding-bottom: 0.4rem !important; }

    .mg-bottom-x-small, .margin-bottom-x-small {
      margin-bottom: 0.57143rem !important; }

    .pd-bottom-x-small, .padding-bottom-x-small {
      padding-bottom: 0.57143rem !important; }

    .mg-bottom-small, .margin-bottom-small {
      margin-bottom: 0.8rem !important; }

    .pd-bottom-small, .padding-bottom-small {
      padding-bottom: 0.8rem !important; }

    .mg-bottom-base, .margin-bottom-base {
      margin-bottom: 1rem !important; }

    .pd-bottom-base, .padding-bottom-base {
      padding-bottom: 1rem !important; }

    .mg-bottom-large, .margin-bottom-large {
      margin-bottom: 1.5rem !important; }

    .pd-bottom-large, .padding-bottom-large {
      padding-bottom: 1.5rem !important; }

    .mg-bottom-x-large, .margin-bottom-x-large {
      margin-bottom: 2rem !important; }

    .pd-bottom-x-large, .padding-bottom-x-large {
      padding-bottom: 2rem !important; }

    .mg-bottom-xx-large, .margin-bottom-xx-large {
      margin-bottom: 3rem !important; }

    .pd-bottom-xx-large, .padding-bottom-xx-large {
      padding-bottom: 3rem !important; }

    .pd-right, .padding-right {
      padding-right: 1rem !important; }

    .mg-right, .margin-right {
      margin-right: 1rem !important; }

    .mg-right-xx-small, .margin-right-xx-small {
      margin-right: 0.4rem !important; }

    .pd-right-xx-small, .padding-right-xx-small {
      padding-right: 0.4rem !important; }

    .mg-right-x-small, .margin-right-x-small {
      margin-right: 0.57143rem !important; }

    .pd-right-x-small, .padding-right-x-small {
      padding-right: 0.57143rem !important; }

    .mg-right-small, .margin-right-small {
      margin-right: 0.8rem !important; }

    .pd-right-small, .padding-right-small {
      padding-right: 0.8rem !important; }

    .mg-right-base, .margin-right-base {
      margin-right: 1rem !important; }

    .pd-right-base, .padding-right-base {
      padding-right: 1rem !important; }

    .mg-right-large, .margin-right-large {
      margin-right: 1.5rem !important; }

    .pd-right-large, .padding-right-large {
      padding-right: 1.5rem !important; }

    .mg-right-x-large, .margin-right-x-large {
      margin-right: 2rem !important; }

    .pd-right-x-large, .padding-right-x-large {
      padding-right: 2rem !important; }

    .mg-right-xx-large, .margin-right-xx-large {
      margin-right: 3rem !important; }

    .pd-right-xx-large, .padding-right-xx-large {
      padding-right: 3rem !important; }

    /*	end of framework
    --------------------------------------  */
    .tnk-card {
      border: none !important; }
      .tnk-card .tnk-card__header--primary {
        background-color: #007dbc;
        color: #f0f2f2; }
      .tnk-card .tnk-card__header--secondary {
        background-color: #81be41;
        color: #f0f2f2; }
      .tnk-card .tnk-card__header--success {
        background-color: #48a900;
        color: #f0f2f2; }
      .tnk-card .tnk-card__header--warning {
        background-color: #ebc500;
        color: #f0f2f2; }
      .tnk-card .tnk-card__header--danger {
        background-color: #e85915;
        color: #f0f2f2; }
      .tnk-card .tnk-card__header--info {
        background-color: #1C415B;
        color: #f0f2f2; }
      .tnk-card .tnk-card__header--gray {
        background-color: #6D7A7D;
        color: #f0f2f2; }
      .tnk-card .tnk-card__header--light {
        background-color: #e2e4e5;
        color: #2c3132; }
      .tnk-card .tnk-card__header--lighter {
        background-color: #f0f2f2;
        color: #2c3132; }
      .tnk-card .tnk-card__header--dark {
        background-color: #2c3132;
        color: #f0f2f2; }
      .tnk-card .tnk-card__header--darker {
        background-color: #161819;
        color: #f0f2f2; }
      .tnk-card .tnk-card__header--tertiary {
        background-color: #002b45;
        color: #f0f2f2; }

    /*	----------------------------
    	VARIABLES
    ----------------------------- */
    /*	General variables  */
    /*	States variables  */
    /*	----------------------------
    	STYLE RULES
    ----------------------------- */
    button {
      background: transparent;
      border: none;
      outline: none; }
      button:focus {
        outline: none; }

    .tnk-button {
      display: inline-block;
      position: relative;
      border: 0;
      color: inherit;
      cursor: pointer;
      padding: 12.5px 15px;
      font-weight: 700;
      border-radius: 4px;
      line-height: 1;
      background: #6D7A7D;
      -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05), 0 0.5px 1px rgba(0, 0, 0, 0.1);
              box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05), 0 0.5px 1px rgba(0, 0, 0, 0.1);
      /*	Generates different themes for button component. */
      /*	Generates different sizes for button component. */
      /*	Disbaled state modifiers  */
      /*	Modifier classes for iconed buttons  */
      /*	Round-edged button modifier class  */
      /*	Makes the button covers over the span of a button's parent width  */ }
      .tnk-button--primary {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #007dbc;
        color: #f0f2f2; }
        .tnk-button--primary:hover {
          background-color: #1a8ac3; }
        .tnk-button--primary.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #007dbc;
          border: solid 1px #007dbc; }
          .tnk-button--primary.tnk-button--outlined:hover {
            background-color: #007dbc;
            color: #f0f2f2; }
          .tnk-button--primary.tnk-button--outlined:focus {
            background-color: #007dbc;
            color: #f0f2f2; }
      .tnk-button--secondary {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #81be41;
        color: #f0f2f2; }
        .tnk-button--secondary:hover {
          background-color: #8ec554; }
        .tnk-button--secondary.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #81be41;
          border: solid 1px #81be41; }
          .tnk-button--secondary.tnk-button--outlined:hover {
            background-color: #81be41;
            color: #f0f2f2; }
          .tnk-button--secondary.tnk-button--outlined:focus {
            background-color: #81be41;
            color: #f0f2f2; }
      .tnk-button--success {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #48a900;
        color: #f0f2f2; }
        .tnk-button--success:hover {
          background-color: #5ab21a; }
        .tnk-button--success.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #48a900;
          border: solid 1px #48a900; }
          .tnk-button--success.tnk-button--outlined:hover {
            background-color: #48a900;
            color: #f0f2f2; }
          .tnk-button--success.tnk-button--outlined:focus {
            background-color: #48a900;
            color: #f0f2f2; }
      .tnk-button--warning {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #ebc500;
        color: #f0f2f2; }
        .tnk-button--warning:hover {
          background-color: #edcb1a; }
        .tnk-button--warning.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #ebc500;
          border: solid 1px #ebc500; }
          .tnk-button--warning.tnk-button--outlined:hover {
            background-color: #ebc500;
            color: #f0f2f2; }
          .tnk-button--warning.tnk-button--outlined:focus {
            background-color: #ebc500;
            color: #f0f2f2; }
      .tnk-button--danger {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #e85915;
        color: #f0f2f2; }
        .tnk-button--danger:hover {
          background-color: #ea6a2c; }
        .tnk-button--danger.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #e85915;
          border: solid 1px #e85915; }
          .tnk-button--danger.tnk-button--outlined:hover {
            background-color: #e85915;
            color: #f0f2f2; }
          .tnk-button--danger.tnk-button--outlined:focus {
            background-color: #e85915;
            color: #f0f2f2; }
      .tnk-button--info {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #1C415B;
        color: #f0f2f2; }
        .tnk-button--info:hover {
          background-color: #33546b; }
        .tnk-button--info.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #1C415B;
          border: solid 1px #1C415B; }
          .tnk-button--info.tnk-button--outlined:hover {
            background-color: #1C415B;
            color: #f0f2f2; }
          .tnk-button--info.tnk-button--outlined:focus {
            background-color: #1C415B;
            color: #f0f2f2; }
      .tnk-button--gray {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #6D7A7D;
        color: #f0f2f2; }
        .tnk-button--gray:hover {
          background-color: #7c878a; }
        .tnk-button--gray.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #6D7A7D;
          border: solid 1px #6D7A7D; }
          .tnk-button--gray.tnk-button--outlined:hover {
            background-color: #6D7A7D;
            color: #f0f2f2; }
          .tnk-button--gray.tnk-button--outlined:focus {
            background-color: #6D7A7D;
            color: #f0f2f2; }
      .tnk-button--light {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #e2e4e5;
        color: #2c3132; }
        .tnk-button--light:hover {
          background-color: #e5e7e8; }
        .tnk-button--light.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #e2e4e5;
          border: solid 1px #e2e4e5; }
          .tnk-button--light.tnk-button--outlined:hover {
            background-color: #e2e4e5;
            color: #2c3132; }
          .tnk-button--light.tnk-button--outlined:focus {
            background-color: #e2e4e5;
            color: #2c3132; }
      .tnk-button--lighter {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #f0f2f2;
        color: #2c3132; }
        .tnk-button--lighter:hover {
          background-color: #f2f3f3; }
        .tnk-button--lighter.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #f0f2f2;
          border: solid 1px #f0f2f2; }
          .tnk-button--lighter.tnk-button--outlined:hover {
            background-color: #f0f2f2;
            color: #2c3132; }
          .tnk-button--lighter.tnk-button--outlined:focus {
            background-color: #f0f2f2;
            color: #2c3132; }
      .tnk-button--dark {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #2c3132;
        color: #f0f2f2; }
        .tnk-button--dark:hover {
          background-color: #414647; }
        .tnk-button--dark.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #2c3132;
          border: solid 1px #2c3132; }
          .tnk-button--dark.tnk-button--outlined:hover {
            background-color: #2c3132;
            color: #f0f2f2; }
          .tnk-button--dark.tnk-button--outlined:focus {
            background-color: #2c3132;
            color: #f0f2f2; }
      .tnk-button--darker {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #161819;
        color: #f0f2f2; }
        .tnk-button--darker:hover {
          background-color: #2d2f30; }
        .tnk-button--darker.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #161819;
          border: solid 1px #161819; }
          .tnk-button--darker.tnk-button--outlined:hover {
            background-color: #161819;
            color: #f0f2f2; }
          .tnk-button--darker.tnk-button--outlined:focus {
            background-color: #161819;
            color: #f0f2f2; }
      .tnk-button--tertiary {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        background-color: #002b45;
        color: #f0f2f2; }
        .tnk-button--tertiary:hover {
          background-color: #1a4058; }
        .tnk-button--tertiary.tnk-button--outlined {
          -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
          background-color: transparent;
          color: #002b45;
          border: solid 1px #002b45; }
          .tnk-button--tertiary.tnk-button--outlined:hover {
            background-color: #002b45;
            color: #f0f2f2; }
          .tnk-button--tertiary.tnk-button--outlined:focus {
            background-color: #002b45;
            color: #f0f2f2; }
      .tnk-button--small {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        padding: 6.25px 7.5px; }
      .tnk-button--base {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        padding: 12.5px 15px; }
      .tnk-button--large {
        -webkit-transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        transition: all 150ms cubic-bezier(0.78, 0.23, 0.33, 0.83);
        padding: 18.75px 22.5px; }
      .tnk-button:disabled {
        opacity: 0.5;
        cursor: not-allowed; }
      .tnk-button--has-icon-front > i.tnk-button__icon {
        margin-right: 1rem; }
      .tnk-button--has-icon-back > i.tnk-button__icon {
        margin-left: 1rem; }
      .tnk-button--pill, .tnk-button--is-pill {
        border-radius: 30px; }
      .tnk-button--full-width, .tnk-button--is-full-width {
        width: 100%; }

    .survey__container ul,
    .survey__container li {
      list-style: none;
      padding: 0; }

    .survey__heading {
      font-weight: bold;
      font-size: 16px; }
      .survey__heading--big {
        font-size: 30px; }
      .survey__heading--medium {
        font-size: 16px; }

    .ces__stars,
    .emoscore__points {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
          flex-wrap: wrap; }

    .ces {
      border-bottom: solid 1px #e2e4e5;
      padding-top: 1.5em;
      padding-bottom: 1.5em;
      color: #535353; }
      @media (max-width: 575px) {
        .ces {
          padding-top: 0;
          padding-bottom: 0; } }
      .ces__point {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        text-align: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        margin-right: 1rem; }
        .ces__point .point {
          -webkit-box-flex: 1;
              -ms-flex: 1 0 33%;
                  flex: 1 0 33%;
          text-align: center;
          margin-bottom: 1rem;
          padding: 1rem 1.5rem;
          font-weight: bold;
          cursor: pointer;
          border: 1px solid #007dbc;
          color: #007dbc;
          border-radius: 6px;
          -webkit-transition: all 200ms ease-in-out;
          transition: all 200ms ease-in-out; }
          .ces__point .point.active {
            color: #f0f2f2;
            background-color: #007dbc; }
          @media (min-width: 576px) {
            .ces__point .point {
              -webkit-box-flex: 0;
                  -ms-flex: 0 0 auto;
                      flex: 0 0 auto; } }
        .ces__point span {
          display: block;
          max-width: 40px; }

    .emoscore {
      border-bottom: solid 1px #e2e4e5;
      padding-top: 1.5em;
      padding-bottom: 1.5em;
      margin-bottom: 1rem;
      color: #535353; }
      @media (max-width: 575px) {
        .emoscore {
          padding-bottom: 0; } }
      .emoscore .emoscore__points {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        margin-top: 1.5rem; }
      .emoscore .point {
        -webkit-box-flex: 1;
            -ms-flex: 1 0 33%;
                flex: 1 0 33%;
        text-align: center;
        margin-right: 1rem;
        margin-bottom: 1rem;
        padding: 1rem 1.5rem;
        font-weight: bold;
        cursor: pointer;
        border: 1px solid #007dbc;
        color: #007dbc;
        border-radius: 30px;
        -webkit-transition: all 200ms ease-in-out;
        transition: all 200ms ease-in-out; }
        .emoscore .point.active {
          color: #f0f2f2;
          background-color: #007dbc; }
        @media (min-width: 576px) {
          .emoscore .point {
            -webkit-box-flex: 0;
                -ms-flex: 0 0 auto;
                    flex: 0 0 auto; } }
        @media (max-width: 575px) {
          .emoscore .point {
            -webkit-box-flex: 0;
                -ms-flex: 0;
                    flex: 0;
            margin-right: 0.75rem;
            padding: 0.5rem 1rem;
            font-size: 13px; } }

    .feedback {
      padding-top: 1.5em;
      padding-bottom: 1.5em; }
      @media (max-width: 575px) {
        .feedback {
          padding-top: 0; } }
      .feedback .survey__heading {
        margin-bottom: 1rem; }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ApiConstant, },
{type: HttpClient, },
{type: FormBuilder, },
{type: Router, },
{type: StorageService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'hideHelpButton': [{ type: Input, args: ['hideHelpButton', ] },],
'media': [{ type: Input, args: ['media', ] },],
'openSuccessDialog': [{ type: Output },],
};
}

function TNKSurveyComponent_tsickle_Closure_declarations() {
/** @type {?} */
TNKSurveyComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKSurveyComponent.ctorParameters;
/** @type {?} */
TNKSurveyComponent.propDecorators;
/** @type {?} */
TNKSurveyComponent.prototype.surveyContentType;
/** @type {?} */
TNKSurveyComponent.prototype.surveyMessage;
/** @type {?} */
TNKSurveyComponent.prototype.emoscorePoint;
/** @type {?} */
TNKSurveyComponent.prototype.cesPoint;
/** @type {?} */
TNKSurveyComponent.prototype.helpWidgetVisible;
/** @type {?} */
TNKSurveyComponent.prototype.helpWidgetForm;
/** @type {?} */
TNKSurveyComponent.prototype.userdata;
/** @type {?} */
TNKSurveyComponent.prototype.widgetErrors;
/** @type {?} */
TNKSurveyComponent.prototype.sendBusy;
/** @type {?} */
TNKSurveyComponent.prototype.validationMessages;
/** @type {?} */
TNKSurveyComponent.prototype.hideHelpButton;
/** @type {?} */
TNKSurveyComponent.prototype.media;
/** @type {?} */
TNKSurveyComponent.prototype.openSuccessDialog;
/** @type {?} */
TNKSurveyComponent.prototype.handlePoint;
/** @type {?} */
TNKSurveyComponent.prototype.api;
/** @type {?} */
TNKSurveyComponent.prototype.http;
/** @type {?} */
TNKSurveyComponent.prototype.fb;
/** @type {?} */
TNKSurveyComponent.prototype.router;
/** @type {?} */
TNKSurveyComponent.prototype.storageService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
